// define pure helper function use in the project
import dayjs from "dayjs";
import { JOURNEY_EMAIL_REGEX } from "./emailValidation";
import { store } from "../services/redux/store";
import CryptoJS from "crypto-js";
import { STATUS_MESSAGES } from "./journeyConstants";
import { Label } from "@mui/icons-material";
import applicationDetailsServices from "../services/api/service/applicationDetails";

export const getQueryString = (queryParams: any) => {
  let queryParamsString = "";
  const params: string[] = Object.keys(queryParams);
  params.forEach((param: any, index: number) => {
    if (index == 0) {
      queryParamsString += `?${param}=${queryParams[param]}`;
    } else {
      queryParamsString += `&${param}=${queryParams[param]}`;
    }
  });
  return queryParamsString;
};

export const loginTypeData = (userData: any) => {
  if (userData?.loginType === "cif") return String(userData?.cif);
  else if (userData?.loginType === "phone") return String(userData?.mobile);
  else if (userData?.loginType === "email") return String(userData?.email?.toLowerCase());
  else return null;
};

export const timeSymbolToMilliseconds = (timeOut: string) => {
  // Extract all leading digits as the number, and the first non-digit as the symbol
  const match = /^([0-9]+)([smh])$/i.exec(timeOut);
  if (!match) return 0;
  const timeNumber = Number(match[1]);
  const timeSymbol = match[2].toLowerCase();
  if (timeSymbol === "s") {
    return 1000 * timeNumber;
  } else if (timeSymbol === "m") {
    return 1000 * 60 * timeNumber;
  } else if (timeSymbol === "h") {
    return 1000 * 60 * 60 * timeNumber;
  }
  return 0;
};

export const encodeToBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader?.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};

export const dateToFinYearOptions = (fromDate: string, toDate?: string) => {
  type optionsType = {
    label: string;
    value: string;
  };

  let finYearsOptions: Array<optionsType> = [];
  let finYearsCount: number = 0;

  type finYearType = {
    year: number;
    month: number;
  };

  const fromFinYear: finYearType = {
    year: +dayjs(fromDate).format("YY"),
    month: +dayjs(fromDate).format("MM"),
  };
  const toFinYear: finYearType = {
    year: +dayjs(toDate && toDate).format("YY"),
    month: +dayjs(toDate && toDate).format("MM"),
  };

  if (toFinYear?.year > fromFinYear?.year) {
    finYearsCount = toFinYear?.year - fromFinYear?.year;
    // from date month count less then or equal to 3 then add one more previous fin year
    if (fromFinYear?.month <= 3) {
      finYearsCount = finYearsCount + 1; // add one more fin year
      fromFinYear.year = fromFinYear.year - 1; // start from 1 fin year previous
    }
    // // to month greater then 3 add one more fin year
    if (toFinYear?.month > 3) {
      finYearsCount = finYearsCount + 1;
    }
  } else if (toFinYear?.year == fromFinYear?.year) {
    // from date month count less then or equal to 3 then add one more previous fin year
    if (fromFinYear?.month <= 3) {
      finYearsCount = finYearsCount + 1; // add one more fin year
      fromFinYear.year = fromFinYear.year - 1; // start from 1 fin year previous
    }
    // to date value month greater then 3 add one more fin year
    if (toFinYear?.month > 3) {
      finYearsCount = finYearsCount + 1;
    }
  }

  for (let index: number = 0; index < finYearsCount; index++) {
    finYearsOptions.push({
      label: `FY${fromFinYear.year + index}-${fromFinYear.year + index + 1}`,
      value: `20${fromFinYear.year + index}`,
    });
  }

  return finYearsOptions;
};

export const capitalizeFirstLetter = (str: string) => {
  return str?.charAt(0).toUpperCase() + str?.toLowerCase().slice(1);
};

export const termLoanPermissionCheck = () => {
  const userLoanCategory = store?.getState()?.auth?.loanCategory;
  const userBusinessSelected = store?.getState()?.auth?.businessType;
  if (userLoanCategory && userBusinessSelected) {
    const selectedLoanCategoryObj = userLoanCategory?.TermLoan?.find(
      (loan: any) => loan?.businessId === userBusinessSelected?.id
    );
    return selectedLoanCategoryObj?.permissionBypass;
  } else {
    return false;
  }
};

export const flexiLoanPermissionCheck = () => {
  const userLoanCategory = store?.getState()?.auth?.loanCategory;
  const userBusinessSelected = store?.getState()?.auth?.businessType;
  if (userLoanCategory && userBusinessSelected) {
    const selectedLoanCategoryObj = userLoanCategory?.Flexi?.find(
      (loan: any) => loan?.businessId === userBusinessSelected?.id
    );
    return selectedLoanCategoryObj?.permissionBypass;
  } else {
    return false;
  }
};

export const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  // Prevent non-numeric input
  if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
    e.preventDefault();
  }
};
export const getInitials = (text: any) => {
  const words = text.trim().split(" ");
  const firstLetter = words[0][0]; // First letter of the first word
  const lastLetter = words[words.length - 1][0]; // First letter of the last word
  return `${firstLetter}${lastLetter}`.toUpperCase(); // Combine and make uppercase
};

export const PositiveNumberValidation = (
  event: React.KeyboardEvent<HTMLInputElement>
) => {
  const charCode = event.key;

  // Allow only digits, backspace, and delete
  if (
    !/[0-9]/.test(charCode) &&
    charCode !== "Backspace" &&
    charCode !== "Delete"
  ) {
    event.preventDefault();
  }
};
// Function to mask mobile numbers
export function maskMobile(mobile: any) {
  if (!mobile || typeof mobile !== "string" || mobile.length < 4) {
    return "Invalid mobile number"; // Handle null, undefined, or invalid input
  }
  // Mask all but the last 4 digits
  return "xxxxxx" + mobile.slice(-4);
}

// Function to mask email addresses
export function maskEmail(email: any) {
  if (!email || typeof email !== "string" || !email.includes("@")) {
    return "Invalid email address"; // Handle null, undefined, or invalid input
  }

  // Split into the local part and domain
  const [localPart, domain] = email.split("@");
  if (!localPart || !domain) {
    return "Invalid email address"; // Additional safety checks
  }

  // Show only the first 3 characters of the local part
  const maskedLocal = localPart.slice(0, 3) + "xxxxxxx";
  return `${maskedLocal}@${domain}`;
}
export function maskEmailOrMobile(data: any) {
  const mobilePattern = /^\d{10}$/; // Pattern for 10-digit mobile number
  const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/; // Pattern for email

  if (mobilePattern.test(data)) {
    // Check if the input is a mobile number
    return "*".repeat(6) + data.slice(-4); // Mask first 6 digits
  } else if (emailPattern.test(data)) {
    // Check if the input is an email address
    const [name, domain] = data.split("@");
    // Mask email name except for the first three characters
    const maskedName = name.slice(0, 3) + "*".repeat(name.length - 3);
    return `${maskedName}@${domain}`; // Return masked email address
  } else {
    return "Invalid input"; // Handle invalid input
  }
}
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Secure navigation utility to prevent open redirect attacks
 * @param path - The path to navigate to
 * @param navigate - React Router's navigate function
 * @param fallbackPath - Optional fallback path if validation fails (defaults to '/dashboard')
 * @returns boolean - true if navigation was successful, false if validation failed
 */
export const secureNavigate = (
  path: string, 
  navigate: (path: string) => void, 
  fallbackPath: string = '/dashboard'
): boolean => {
  // Validate the path to prevent open redirect attacks
  if (!path) {
    return false;
  }

  // Only allow internal paths (starting with /)
  if (path.startsWith('/') && !path.includes('://')) {
    // Additional validation: ensure path doesn't contain suspicious patterns
    const suspiciousPatterns = [
      /javascript:/i,
      /data:/i,
      /vbscript:/i,
      /on\w+\s*=/i, // event handlers
      /<script/i,   // script tags
    ];

    const hasSuspiciousPattern = suspiciousPatterns.some(pattern => pattern.test(path));
    
    if (hasSuspiciousPattern) {
      return false;
    }

    // Path is safe, proceed with navigation
    navigate(path);
    return true;
  } else {
    // Optionally redirect to fallback path
    if (fallbackPath && fallbackPath.startsWith('/')) {
      navigate(fallbackPath);
    }
    
    return false;
  }
};

/**
 * Maps gender codes to their full names and vice versa
 * @param input - Gender code (F, M, O, T) or full name (Female, Male, Other, Transgender)
 * @returns The corresponding full name or code, or the original input if no match found
 */
export const mapGender = (): any => {
  const genderArray = [
    { code: 'F', name: 'Female' },
    { code: 'M', name: 'Male' },
    { code: 'O', name: 'Other' },
    { code: 'T', name: 'Prefer Not To Say' }
  ];

  return genderArray;
};

export const empTypeOptions = [
    { label: 'Farmer', value: 'Farmer' },
    { label: 'Salaried', value: 'Salaried' },
    { label: 'SEP', value: 'SEP' },
    { label: 'SENP', value: 'SENP' },
    { label: 'Others', value: 'Others' }
  ];

// Removes leading salutations/relationships like "S/O", "S.O", "Son of"
export function removeSalutation(fullName: string) {
  if (!fullName) return "";
  // Match at start: S/O, S.O, or "Son of" (case-insensitive), with optional spaces/punctuation
  const salutationRegex = new RegExp(
    // start of string ^
    '^\\s*(' +
    's\\s*[/.-]?\\s*o' +           // S/O, S.O
    '|son\\s+of' +                 // Son of
    '|d\\s*[/.-]?\\s*o' +          // D/O, D.O
    '|daughter\\s+of' +            // Daughter of
    '|w\\s*[/.-]?\\s*o' +          // W/O, W.O
    '|wife\\s+of' +                // Wife of
    '|c\\s*[/.-]?\\s*o' +          // C/O, C.O
    '|care\\s+of' +                // Care of
    '|f\\s*[/.-]?\\s*o' +          // F/O (Father of)
    '|father\\s+of' +              // Father of
    '|m\\s*[/.-]?\\s*o' +          // M/O (Mother of)
    '|mother\\s+of' +              // Mother of
    ')[:\\s-]*',                     // optional colon/space/hyphen
    'i'
  );
  const cleanedName = fullName.replace(salutationRegex, "");
  return cleanedName.trim();
}


export const formatDateToDDMMYYYY = (date: string) => {
  return new Date(date)
    .toLocaleDateString("en-GB", { timeZone: "Asia/Kolkata" })
    .replace(/\//g, "-");
};

export function debounce(fn: (...args: any[]) => void, delay: number) {
  let timer: any;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}


export const handleOwnershipStatusValue = (value: any) => {
  switch (value) {
    case "Rented":
      return 276;
    case "Owned":
      return 277;
  }
};

export const handleUnwanted = (str: string): string => {
  if (str === "-") return "";
  // Remove special characters except spaces, hyphens, and apostrophes
  return str;
}

export const splitAddressByWords = (text: string) => {
  const maxLen = 50;
  const maxLines = 3;

  const words = text.split(" ");
  const lines: string[] = [];
  let currentLine = "";

  for (const word of words) {
    const nextLine = currentLine
      ? `${currentLine} ${word}`
      : word;

    if (nextLine.length > maxLen) {
      lines.push(currentLine.trim());
      currentLine = word;

      if (lines.length === maxLines) break;
    } else {
      currentLine = nextLine;
    }
  }

  if (lines.length < maxLines && currentLine) {
    lines.push(currentLine.trim());
  }

  return lines;
};

// Fetch latest notifications for the given trackingId and update recentUpdates
export  const formatShortMonthWithTime = (isoString: string): string => {
    if (!isoString) return "";
    const dateObject = new Date(isoString);
    if (isNaN(dateObject.getTime())) return "";
    const day = dateObject.getDate();
    const year = dateObject.getFullYear();
    const shortMonths = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = shortMonths[dateObject.getMonth()];
    const timeStr = dateObject.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day} ${month} ${year}, ${timeStr}`;
  };

export const formatDOB = (value: number | string) => {
  if (!value) return "-";

  // Case 1: YYYY-MM-DD string
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-");
    return `${day}-${month}-${year}`;
  }

  // Case 2: timestamp (number or numeric string)
  const date = new Date(Number(value));
  if (isNaN(date.getTime())) return "-";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

// Function to show messages based on Application Status for Loan Details Card
export function getApplicationMessage(
  status: string | undefined,
  normalizedProvisionalOffer: string | undefined,
  partnerFlag?: boolean | any
) {
  const normalizedStatus = (status || "").toLowerCase();
  const failedStatuses = [
    "application rejected",
    "declined by credit",
  ].map((s) => s.toLowerCase());

  if (partnerFlag && normalizedStatus === "sanctioned".toLowerCase()) {
    return STATUS_MESSAGES.SANCTIONED;
  }

  if (partnerFlag && normalizedStatus === "disbursed".toLowerCase()) {
    return STATUS_MESSAGES.DISBURSED;
  }

  if (partnerFlag && normalizedStatus === "application closed".toLowerCase()) {
    return STATUS_MESSAGES.CLOSED;
  }

  if (failedStatuses.includes(normalizedStatus)) {
    return STATUS_MESSAGES.REJECTED || STATUS_MESSAGES.DECLINED_BY_CREDIT;
  }

  if (!partnerFlag && normalizedProvisionalOffer?.toLowerCase() === "yes") {
    return STATUS_MESSAGES.PROVISIONAL_OFFER;
  }

  if (!partnerFlag && normalizedProvisionalOffer?.toLowerCase() === "no") {
    return STATUS_MESSAGES.NO_PROVISIONAL_OFFER;
  }

  return partnerFlag ? STATUS_MESSAGES.PROVISIONAL_LOCKED : STATUS_MESSAGES.COMPLETE_DETAILS;
}

// Case-insensitive helper
export const normalize = (value: string | undefined) => value?.toLowerCase();
export const mapCollateral = (): any => {
  const collateralArray = [
    { value: '307', label: 'Fixed Deposit' },
    { value: '308', label: 'Property' },
    { value: '309', label: 'Saving' },
  ];

  return collateralArray;
};
export const getCoApplicantList=(applicationData:any)=>{
 const CO_APPLICANT_SOURCE_STEPS = [
    { horizontalIndex: 1},
    { horizontalIndex: 3 },
  ];
  const TARGET_VERTICAL_STEPS = [
    'Co-Applicant Details',
    'Co-Applicant Aditional Details',
  ];
  const fieldsList: any = CO_APPLICANT_SOURCE_STEPS.flatMap(
    ({ horizontalIndex }) =>
      applicationData?.horizontalSteps?.[horizontalIndex]?.verticalSteps
        ?.filter((step: any) =>{
          const cleanApiName = (step?.verticalStepName || "")
            .trim()
            .replace(/['"]/g, ""); // Removes literal single and double quotes completely
          return TARGET_VERTICAL_STEPS.includes(cleanApiName);
        })
        ?.flatMap((step: any) => step?.fields || []) || []
  ).filter(
    (field: any, index: number, allFields: any[]) => {
      const currentKey = Object.keys(field || {})[0];

      return (
        allFields.findIndex((candidate: any) => {
          const candidateKey = Object.keys(candidate || {})[0];

          return candidateKey === currentKey;
        }) === index
      );
    }
  );
  return fieldsList;
}

/**
 * Merges Format 1 and Format 2 arrays of objects.
 * Maps completion rates from format2 into format1 structures.
 * * @param {Array} format1Array - The base layout array (with innerData, label, etc.)
 * @param {Array} format2Array - The progress state array (with completionPercentages)
 * @returns {Array} A new array combining structures with updated completion rates.
 */
export const mergeAndCalculateCompletion = (format1Array: any, format2Array: any) => {
  // Edge case handling if arrays are missing
  if (!format1Array || !format2Array) return [];

  return format1Array.map((h1Step: any) => {
    // Find the corresponding horizontal step by matching names instead of index
    const h2Step = (format2Array || []).find(
      (h2: any) => h2.horizontalStepName === h1Step.label
    ) || {};
    // Convert parent completion rate to a string percentage (default to "0%" if undefined)
    let horizontalPercentage = h2Step.completionPercentage !== undefined 
      ? `${h2Step.completionPercentage}%` 
      : "0%";
    if(h2Step.horizontalStepName=='Additional Details & Documents'){
      // 1. Filter out index 1
      const filteredSteps = h2Step.verticalSteps.filter((item:any) => item?.verticalStepName !== 'Co-Applicant Aditional Details');
      // 2. Sum up the percentages of the remaining items
      const totalPercentage = filteredSteps.reduce((sum:any, step:any) => sum + step.completionPercentage, 0);

      // 3. Calculate the average and round it to 1 decimal place (e.g., 66.7%)
      horizontalPercentage = filteredSteps.length > 0 
        ? `${Number((totalPercentage / filteredSteps.length).toFixed(1))}%` 
        : "0%";
      
    }
    return {
      ...h1Step,
      // Update/add horizontal completionRate
      completionRate: horizontalPercentage,
      status: h2Step.completionPercentage === 100 ? "completed" : h1Step.status,

      // Loop through vertical items inside innerData
      innerData: (h1Step.innerData || []).map((v1Step: any) => {
        // Find the matching vertical step in format2 by id, then by name
        const normalizeName = (name: string) =>
          String(name || "")
            .toLowerCase()
            .replace(/&/g, "and")
            .replace(/[^a-z0-9]/g, "");
        let v2Step =
          (h2Step.verticalSteps || []).find(
            (v2: any) =>
              v1Step.verticalStepId != null &&
              v2.verticalStepId === v1Step.verticalStepId,
          ) ||
          (h2Step.verticalSteps || []).find(
            (v2: any) =>
              normalizeName(v2?.verticalStepName || "") ===
              normalizeName(v1Step?.verticalStepName || ""),
          ) ||
          {};
        // Convert child completion rate to a string percentage
        let verticalPercentage = v2Step.completionPercentage !== undefined 
          ? `${v2Step.completionPercentage}%` 
          : "0%";
        if (v2Step?.verticalStepName === "Co-Applicant Details" ) {
          // Look inside the sections array for "Loan Details"
          const matchingSection = v2Step.sections?.find(
            (sec: any) => (sec?.sectionName || "").trim().toLowerCase() === "co-applicant details"
          );
          if (matchingSection) {
            // Get percentage from the section (handles both string "100.00" and number formats)
            const rawPercent = parseFloat(matchingSection.completionPercentage);
            verticalPercentage = rawPercent !== undefined ? `${rawPercent}%` : "0%";
            v2Step.isCompleted=true;
          } else {
            // Fallback to parent step percentage if section isn't explicitly found
            verticalPercentage = parseFloat(v2Step.completionPercentage) !== undefined ? `${v2Step.completionPercentage}%` : "0%";
          }
        } 
        return {
          ...v1Step,
          // Inject completionRate into the vertical step object
          completionRate: verticalPercentage,
          // Sync completion status flags
          isCompleted: v2Step.isCompleted || false
        };
      })
    };
  });
};

export const getCoApplicantAverageProgress = (
  applicationData: any,
  coAppPrefix: string // e.g., "coApplicant3" or "coApplicant4"
): number => {
  // 1. Collect all matching horizontal steps
  const targetHorizontalSteps = (applicationData || []).filter((h: any) => {
    const name = h?.horizontalStepName?.trim();
    return (
      name === "Applicant & Loan Details" ||
      name === "Additional Details & Documents"
    );
  });

  if (targetHorizontalSteps.length === 0) return 0;

  // 2. Gather all sections belonging to this co-applicant
  const existingSections: any[] = [];

  targetHorizontalSteps.forEach((hStep: any) => {
    (hStep?.verticalSteps || []).forEach((vStep: any) => {
      const vName = vStep?.verticalStepName?.trim();
      if (
        vName === "Co-Applicant Details" ||
        vName === "Co-Applicant Aditional Details" ||
        vName === "Co-Applicant Additional Details"
      ) {
        const matching = (vStep?.sections || []).filter((sec: any) =>
          sec?.sectionKey?.startsWith(coAppPrefix)
        );
        existingSections.push(...matching);
      }
    });
  });

  // 3. Map existing section types into a lookup map
  // Expected keys for each co-applicant: "basic", "address", "employment"
  const expectedSectionTypes = ["basic", "address", "employment"];
  const sectionScores: Record<string, number> = {
    basic: 0,
    address: 0,
    employment: 0,
  };
  existingSections.forEach((sec: any) => {
    const key = sec?.sectionKey?.toLowerCase() || "";
    const rawPercent = sec?.completionPercentage;
    const numericPercent =
      typeof rawPercent === "string" ? parseFloat(rawPercent) : rawPercent || 0;

    if (key.includes("basic")) {
      sectionScores.basic = isNaN(numericPercent) ? 0 : numericPercent;
    } else if (key.includes("address")) {
      sectionScores.address = isNaN(numericPercent) ? 0 : numericPercent;
    } else if (key.includes("employment")) {
      sectionScores.employment = isNaN(numericPercent) ? 0 : numericPercent;
    }
  });
  // 4. Sum up all 3 section scores (missing sections naturally stay 0)
  const totalSum = expectedSectionTypes.reduce(
    (sum, type) => sum + sectionScores[type],
    0
  );

  // 5. Always divide by 3 to reflect overall completion across basic, address, and employment
  return Math.round(totalSum / 3);
};

export const numberToWord: Record<number, string> = {
  1: "ONE",
  2: "TWO",
  3: "THREE",
  4: "FOUR",
  5: "FIVE",
  6: "SIX",
  7: "SEVEN",
  8: "EIGHT",
  9: "NINE",
  10: "TEN",
  11: "ELEVEN",
  12: "TWELVE",
  13: "THIRTEEN",
  14: "FOURTEEN",
  15: "FIFTEEN",
  16: "SIXTEEN",
  17: "SEVENTEEN",
  18: "EIGHTEEN",
  19: "NINETEEN",
  20: "TWENTY",
  21: "TWENTY_ONE",
  22: "TWENTY_TWO",
  23: "TWENTY_THREE",
  24: "TWENTY_FOUR",
  25: "TWENTY_FIVE",
};

export const normalizeCollateralFieldKey = (name: string): string =>
  String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const fieldBelongsToCollateralNumber = (
  fieldName: string,
  collateralNumber: number,
): boolean => {
  const resolvedNumber = getCollateralNumberFromFieldName(fieldName);
  return resolvedNumber !== null && resolvedNumber === collateralNumber;
};

// Pulls the Collateral Details vertical step's last-FETCHED field values
// (plain { fieldName: savedValue } pairs) out of the raw fetch-application-
// data response — the same lookup isCollateralStepAlreadySaved uses.
// Exported so DynamicForm.tsx's own snapshot-building can merge these in
// too, alongside live Formik/formData values — see
// isCollateralContinueGenuinelySaved and buildCollateralGroupValueSnapshot
// below for why that consistency matters (a mismatch between "what got
// seeded as saved" and "what gets compared against it" means Continue can
// never re-latch true, e.g. right after a fresh page load).
export const extractFetchedCollateralVals = (
  fetchUserApplicationData: any,
): Record<string, any> => {
  const fetchedVals: Record<string, any> = {};
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (Array.isArray(steps)) {
    const additionalDetailsStep = steps.find(
      (step: any) =>
        step?.horizontalStepName?.trim().toLowerCase() ===
        "additional details & documents",
    );
    const collateralVerticalStep = additionalDetailsStep?.verticalSteps?.find(
      (vStep: any) => vStep?.verticalStepName?.toLowerCase().includes("collateral"),
    );
    (collateralVerticalStep?.fields || []).forEach((field: any) => {
      if (!field || typeof field !== "object") return;
      Object.keys(field).forEach((key) => {
        fetchedVals[key] = field[key];
      });
    });
  }
  return fetchedVals;
};

// Every saved field value across all of fetchUserApplicationData.horizontalSteps
// (co-applicant basics, collateral co-owners, etc.) as one name -> value map.
export const extractFetchedApplicationVals = (
  fetchUserApplicationData: any,
): Record<string, any> => {
  const fetchedVals: Record<string, any> = {};
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (!Array.isArray(steps)) return fetchedVals;
  steps.forEach((step: any) => {
    (step?.verticalSteps || []).forEach((vStep: any) => {
      (vStep?.fields || []).forEach((field: any) => {
        if (!field || typeof field !== "object") return;
        Object.keys(field).forEach((key) => {
          fetchedVals[key] = field[key];
        });
      });
    });
  });
  return fetchedVals;
};

// save-collateral doesn't refresh fetchUserApplicationData, so the co-applicant
// First/Last Name & Mobile lock (isCoApplicantFieldLockedByCoOwner, which reads
// the fetched snapshot) only picked up newly saved co-owners after a reload.
// Mirrors the just-saved co-owner Name / Phone / Ownership % values into the
// fetched Collateral Details vertical step so the lock applies immediately.
export const mergeSavedCoOwnersIntoFetchedData = (
  fetchUserApplicationData: any,
  savedValues: Record<string, any>,
  collateralNumbers: number[],
): any => {
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (!Array.isArray(steps)) return fetchUserApplicationData;

  const toValue = (val: any) =>
    val && typeof val === "object" ? val.value ?? val.label ?? "" : val ?? "";
  const savedCoOwnerVals: Record<string, any> = {};
  Object.keys(savedValues || {}).forEach((key) => {
    const match = key.match(
      /^coOwnerCollateral(\d+)(?:_\d+)?(Name|PhoneNumber|OwnershipPercentage)$/,
    );
    if (!match || !collateralNumbers.includes(Number(match[1]))) return;
    savedCoOwnerVals[key] = String(toValue(savedValues[key]));
  });
  if (Object.keys(savedCoOwnerVals).length === 0) return fetchUserApplicationData;

  const additionalIdx = steps.findIndex(
    (step: any) =>
      step?.horizontalStepName?.trim().toLowerCase() ===
      "additional details & documents",
  );
  if (additionalIdx < 0) return fetchUserApplicationData;

  const verticalSteps = Array.isArray(steps[additionalIdx]?.verticalSteps)
    ? [...steps[additionalIdx].verticalSteps]
    : [];
  let collateralIdx = verticalSteps.findIndex((vStep: any) =>
    vStep?.verticalStepName?.toLowerCase().includes("collateral"),
  );
  if (collateralIdx < 0) {
    verticalSteps.push({ verticalStepName: "Collateral Details", fields: [] });
    collateralIdx = verticalSteps.length - 1;
  }

  const pending = { ...savedCoOwnerVals };
  const fields = (verticalSteps[collateralIdx]?.fields || []).map((field: any) => {
    if (!field || typeof field !== "object") return field;
    const key = Object.keys(field)[0];
    if (!(key in pending)) return field;
    const updated = { [key]: pending[key] };
    delete pending[key];
    return updated;
  });
  Object.keys(pending).forEach((key) => fields.push({ [key]: pending[key] }));
  verticalSteps[collateralIdx] = { ...verticalSteps[collateralIdx], fields };

  const horizontalSteps = [...steps];
  horizontalSteps[additionalIdx] = { ...steps[additionalIdx], verticalSteps };
  return { ...fetchUserApplicationData, horizontalSteps };
};

// Collateral group numbers that structurally EXIST right now per
// state.stepper.horizontalSteps — the field-definition schema
// addCollateralFields/removeCollateralFields themselves edit (via
// dispatch(setHorizontalSteps(...))), found the same way those two already
// look it up: scan every horizontal step's verticalSteps for the one
// labeled "Collateral Details", then read its field names. This can know
// about a group that has literally no value anywhere yet (not even a blank
// Formik key) — e.g. right after a page load where the schema already
// lists 3 collateral groups but the 3rd was never actually filled in/saved,
// so it never made it into fetchedVals or live Formik values at all.
export const getCollateralGroupNumbersFromHorizontalSteps = (
  horizontalSteps: any,
): number[] => {
  const numbers = new Set<number>();
  (Array.isArray(horizontalSteps) ? horizontalSteps : []).forEach((hStep: any) => {
    (hStep?.verticalSteps || []).forEach((vStep: any) => {
      if (vStep?.stepLabel !== "Collateral Details") return;
      (vStep?.fields || []).forEach((field: any) => {
        const match = String(field?.name || "").match(/^collateral(\d*)type$/i);
        if (match) numbers.add(Number(match[1] || 1));
      });
    });
  });
  return Array.from(numbers).sort((a, b) => a - b);
};

// Snapshots one collateral group's own filled-in field values out of `vals`
// (already merged fetched+live, see extractFetchedCollateralVals) as a
// stable JSON string — the same string, byte for byte, both when a group is
// first recorded as "genuinely saved" and later when that's re-checked.
// Exported so every caller that needs either half of that comparison
// (recording it, or checking it) builds the string identically.
export const buildCollateralGroupValueSnapshot = (
  vals: Record<string, any> | undefined | null,
  groupNumber: number,
): string => {
  const relevant: Record<string, any> = {};
  Object.keys(vals || {})
    .filter((key) => fieldBelongsToCollateralNumber(key, groupNumber))
    .sort()
    .forEach((key) => {
      const raw = (vals as any)[key];
      const resolved =
        raw && typeof raw === "object" ? (raw as any).value ?? (raw as any).label : raw;
      if (resolved !== undefined && resolved !== null && String(resolved).trim() !== "") {
        relevant[key] = resolved;
      }
    });
  return JSON.stringify(relevant);
};

// Shared "is the Reference & Collateral step's Continue button genuinely
// earned" check — EVERY present collateral group must be genuinely saved,
// not just any one of them. Clicking "Add More" opens a new, blank group
// immediately, so Continue must go right back to disabled at that moment —
// even though an earlier group is still genuinely saved — until that new
// group is saved too (Save & Next). Removing a group drops it out of this
// check entirely, so the remaining groups alone decide again.
//
// Pulled out so both DynamicForm.tsx (the reconcile useEffect that runs on
// formData/fields/horizontalSteps changes) and CollateralDetails.tsx (which
// can call this immediately after its own Add More / Remove handlers, since
// those don't always change something DynamicForm's effect is watching)
// compute the exact same answer instead of drifting apart.
export const isCollateralContinueGenuinelySaved = (
  vals: Record<string, any> | undefined | null,
  lastSavedSnapshotByGroup: Record<number, string> | undefined | null,
  // Optional: the raw fetch-application-data response (same shape
  // isCollateralStepAlreadySaved reads). When given, the Collateral Details
  // vertical step's last-FETCHED field values are pulled out first and used
  // as a base — the live `vals` passed in still win per-key on top of that —
  // so a caller doesn't need Formik/formData to already carry every key
  // (e.g. right after Add More/Remove, before a re-render has caught up).
  fetchUserApplicationData?: any,
  // Optional: state.stepper.horizontalSteps (the field-definition schema).
  // When given, a collateral group that exists there but has no value
  // anywhere yet (not even a blank Formik key) still gets picked up below —
  // see getCollateralGroupNumbersFromHorizontalSteps.
  horizontalSteps?: any,
): boolean => {
  const fetchedVals = extractFetchedCollateralVals(fetchUserApplicationData);
  const safeVals = { ...fetchedVals, ...(vals || {}) };

  // "Has Collateral?" gate, resolved off the merged (fetched + live) values
  // so a fresh in-session answer still wins over a stale fetched one.
  const rawHasCollateral = (safeVals as any)?.hasCollateral;
  const hasCollateralAnswer = String(
    rawHasCollateral && typeof rawHasCollateral === "object"
      ? (rawHasCollateral as any).value ?? (rawHasCollateral as any).label
      : rawHasCollateral ?? "",
  ).trim().toLowerCase();
  // "No" has no real collateral to genuinely save — Continue for that
  // answer is earned elsewhere (saveNoCollateralAnswer), not through this
  // per-group check.
  if (hasCollateralAnswer === "no") return false;
  // The question hasn't been answered yet (undefined/blank) — nothing here
  // to disqualify Continue over.
  if (hasCollateralAnswer === "") return true;
  // "yes" falls through to the per-group check below.

  // A group only counts as "present" here once its own Type field has a
  // real (even if not-yet-saved) value — `undefined`/`null` specifically
  // means Remove just cleared it (see removeCollateralFields, which uses
  // setFieldValue(..., undefined)), so that leftover key must NOT keep
  // counting as the "current" group once it's gone. An "Add More"-d group's
  // Type field is seeded with "" (addCollateralFields), which still counts
  // — it's blank, not removed — so it's the one picked below and correctly
  // disqualifies the check until it's actually filled in and saved.
  const groupNumbers = new Set<number>();
  Object.keys(safeVals).forEach((key) => {
    const match = key.match(/^collateral(\d*)type$/i);
    if (!match) return;
    const raw = (safeVals as any)[key];
    if (raw === undefined || raw === null) return;
    groupNumbers.add(Number(match[1] || 1));
  });
  // Union in whatever the schema itself lists, so a group with zero value
  // anywhere (not even a blank live key) still counts as present and
  // disqualifies the check below, instead of being invisible to it.
  getCollateralGroupNumbersFromHorizontalSteps(horizontalSteps).forEach((n) =>
    groupNumbers.add(n),
  );
  // Collateral 1's field definitions are permanent (removeCollateralFields
  // never strips them from horizontalSteps, only blanks their values), so a
  // completely empty group 1 alongside another group is just that leftover
  // placeholder — CollateralDetails' displayedCollateralNumbers hides it
  // from the UI for the same reason. Counting it here left Continue stuck
  // disabled even once the only visible collateral (e.g. 2) was saved.
  if (
    groupNumbers.size > 1 &&
    groupNumbers.has(1) &&
    buildCollateralGroupValueSnapshot(safeVals, 1) === "{}"
  ) {
    groupNumbers.delete(1);
  }
  const presentGroupNumbers = Array.from(groupNumbers).sort((a, b) => a - b);
  if (presentGroupNumbers.length === 0) return false;


  // Every present group must genuinely match what was last saved for it —
  // one blank/unsaved/edited-since group anywhere disqualifies the whole
  // step, not just the newest one.
  for (const n of presentGroupNumbers) {
    const snapshot = buildCollateralGroupValueSnapshot(safeVals, n);
    // An empty snapshot ("{}") is this group with nothing filled in yet.
    if (snapshot === "{}") return false;
    // A snapshot with any blank value inside it is a partially-filled group
    // — still not genuinely saved.
    const hasBlankValue = Object.values(JSON.parse(snapshot)).some(
      (v) => v === null || v === undefined || String(v).trim() === "",
    );
    if (hasBlankValue) return false;
    if (lastSavedSnapshotByGroup?.[n] !== snapshot) return false;
  }
  return true;
};

export const getCollateralNumberFromBaseField = (
  fieldName: string,
): number | null => {
  const normalized = String(fieldName || "");
  const match = normalized.match(/^collateral(\d+)/i);
  if (match) return Number(match[1]);
  if (/^collateral/i.test(normalized) && !/^collateral\d+/i.test(normalized)) {
    return 1;
  }
  return null;
};

export const getCollateralNumberFromFieldName = (
  fieldName: string,
): number | null => {
  if (/^coOwnerCollateral/i.test(String(fieldName || ""))) {
    return getCollateralNumberFromCoOwnerField(fieldName);
  }
  return getCollateralNumberFromBaseField(fieldName);
};

export const getCollateralFormValue = (
  currentValues: Record<string, any> | undefined,
  collateralNumber: number,
  fieldSuffix: string,
): any => {
  if (!currentValues) return undefined;

  const normalizedSuffix = normalizeCollateralFieldKey(fieldSuffix);
  const exactKey = `collateral${collateralNumber}${fieldSuffix}`;
  if (exactKey in currentValues) return currentValues[exactKey];

  for (const key of Object.keys(currentValues)) {
    if (getCollateralNumberFromBaseField(key) !== collateralNumber) continue;
    const normalizedKey = normalizeCollateralFieldKey(key);
    if (normalizedKey.endsWith(normalizedSuffix)) {
      return currentValues[key];
    }
  }

  return undefined;
};

/** Find collateral city/state/country field names from form defs + form values. */
export const resolveCollateralAddressFieldNames = (
  fields: any[] = [],
  formValues: Record<string, any> = {},
  collateralNumber: number | string = 1,
): { city?: string; state?: string; country?: string; pincode?: string } => {
  const num = Number(collateralNumber) || 1;
  const candidates = new Set<string>();

  (fields || []).forEach((field: any) => {
    if (field?.name) candidates.add(String(field.name));
  });
  Object.keys(formValues || {}).forEach((key) => candidates.add(key));

  [
    `collateral${num}City`,
    `collateral${num}city`,
    `collateral${num}State`,
    `collateral${num}state`,
    `collateral${num}Country`,
    `collateral${num}country`,
    `collateral${num}Pincode`,
    `collateral${num}pincode`,
    `collateral${num}PinCode`,
  ].forEach((key) => candidates.add(key));

  if (num === 1) {
    [
      "collateralCity",
      "collateralcity",
      "collateralState",
      "collateralstate",
      "collateralCountry",
      "collateralcountry",
      "collateralPincode",
      "collateralpincode",
      "collateralPinCode",
    ].forEach((key) => candidates.add(key));
  }

  const findBySuffix = (suffixes: string[]) =>
    Array.from(candidates).find((name) => {
      if (/^coOwnerCollateral/i.test(name)) return false;
      if (!fieldBelongsToCollateralNumber(name, num)) return false;

      const normalized = normalizeCollateralFieldKey(name);
      if (
        normalized.includes("addresstype") ||
        normalized.includes("addressline") ||
        normalized.includes("property") ||
        normalized.includes("collateraltype")
      ) {
        return false;
      }

      return suffixes.some((suffix) => normalized.endsWith(suffix));
    });

  return {
    city: findBySuffix(["city", "cityname"]),
    state: findBySuffix(["state", "statename"]),
    country: findBySuffix(["country", "countryname"]),
    pincode: findBySuffix(["pincode"]),
  };
};

export const applyCollateralAddressFromPincode = (
  formikRef: any,
  options: {
    fields?: any[];
    collateralNumber: number | string;
    cityName?: string;
    stateName?: string;
    countryName?: string;
    countries?: Array<{ value?: string | number; label?: string }>;
    clear?: boolean;
    onUpdate?: (patch: Record<string, any>) => void;
  },
) => {
  if (!formikRef?.current?.setFieldValue) return;

  const {
    fields = [],
    collateralNumber,
    cityName = "",
    stateName = "",
    countryName = "",
    countries = [],
    clear = false,
    onUpdate,
  } = options;

  const formValues = formikRef.current.values || {};
  const addressFields = resolveCollateralAddressFieldNames(
    fields,
    formValues,
    collateralNumber,
  );

  const matchedCountry =
    (countries || []).find(
      (opt) =>
        String(opt?.label || "").trim().toLowerCase() ===
          String(countryName || "").trim().toLowerCase() ||
        String(opt?.value || "").trim().toLowerCase() ===
          String(countryName || "").trim().toLowerCase(),
    ) || null;

  // Prefer plain string (same as reference address pincode fill) so text + autocomplete both render.
  const countryValue = clear
    ? ""
    : String(matchedCountry?.label || countryName || "").trim();

  const patch: Record<string, any> = {};
  const setValue = (fieldName: string | undefined, value: any) => {
    if (!fieldName) return;
    formikRef.current.setFieldValue(fieldName, value, false);
    patch[fieldName] = value;
  };

  setValue(addressFields.city, clear ? "" : cityName || "");
  setValue(addressFields.state, clear ? "" : stateName || "");
  setValue(addressFields.country, countryValue);

  if (onUpdate && Object.keys(patch).length > 0) {
    onUpdate(patch);
  }
};

export const getCoOwnerCollateralFormValue = (
  currentValues: Record<string, any> | undefined,
  collateralNumber: number,
  fieldSuffix: string,
): any => {
  if (!currentValues) return undefined;

  const normalizedSuffix = normalizeCollateralFieldKey(fieldSuffix);

  for (const key of Object.keys(currentValues)) {
    if (getCollateralNumberFromCoOwnerField(key) !== collateralNumber) continue;
    const normalizedKey = normalizeCollateralFieldKey(key);
    if (normalizedKey.endsWith(normalizedSuffix)) {
      return currentValues[key];
    }
  }

  return undefined;
};

// Collateral field records don't consistently carry their identifier under
// `.id` — records still shaped by the older combined "Reference & Collateral
// Details" backend step (see isReferenceCollateralVerticalStepLabel below)
// can have it under `.formFieldId`/`.fieldId` instead. Any code resolving a
// collateral field's id for a save/delete API call should use this fallback
// chain rather than reading `.id` alone, or it silently treats the field as
// id-less for accounts still on the older shape.
export const resolveCollateralFieldId = (field: {
  id?: any;
  formFieldId?: any;
  fieldId?: any;
}) => field?.id ?? field?.formFieldId ?? field?.fieldId;

// fetchUserApplicationData.horizontalSteps is the raw fetch-application-data
// response — each field there is a single-key `{ [fieldName]: savedValue }`
// object. Scans every step for the field name directly against this fetched
// (i.e. actually persisted) data, as opposed to Formik/redux `formData`
// (which reflects whatever's currently typed, saved or not).
export const getFetchedStepFieldValue = (
  fetchUserApplicationData: any,
  fieldName: string,
): any => {
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (!Array.isArray(steps)) return undefined;
  for (const hStep of steps) {
    for (const vStep of hStep?.verticalSteps || []) {
      for (const field of vStep?.fields || []) {
        if (field && typeof field === "object" && fieldName in field) {
          return field[fieldName];
        }
      }
    }
  }
  return undefined;
};

// The Reference & Collateral step's Continue button should only re-enable
// itself on revisit (e.g. Previous from Document & Consent, or resuming an
// application) when Collateral was actually already saved to the backend —
// "No" answered, or a real collateral1... group with a saved Type. Reading
// from the fetched application data (not live Formik/redux values) keeps
// this from firing just because the applicant is mid-typing, unsaved.
export const isCollateralStepAlreadySaved = (
  fetchUserApplicationData: any,
  hasCollateralAnswer: string,
  // Optional cross-check: collateral group number -> whether the LOS
  // collateral entity itself (fetched via api/v1/user-application/fetch-
  // collateral) is ACTIVE. A group can still show filled field values below
  // after being soft-deleted server-side, so a group known to be inactive is
  // never trusted even if its horizontalSteps values look filled. A group
  // absent from this map (no data fetched yet, or the API didn't report on
  // it) falls back to trusting horizontalSteps alone.
  activeCollateralStatusByGroup?: Record<string, boolean>,
): boolean => {
  // "No" is itself a complete, saved answer — nothing else needs checking.
  if (hasCollateralAnswer === "no") return true;

  // "Yes" needs more than just a Type value to count as genuinely saved —
  // a single filled key could be a stray/partial record. Require at least
  // two distinct filled keys WITHIN THE SAME collateral<N> group before
  // treating that group as confirmed.
  const steps = fetchUserApplicationData?.horizontalSteps;
  if (!Array.isArray(steps)) return false;

  const additionalDetailsStep = steps.find(
    (step: any) =>
      step?.horizontalStepName?.trim().toLowerCase() ===
      "additional details & documents",
  );
  const collateralVerticalStep = additionalDetailsStep?.verticalSteps?.find(
    (vStep: any) =>
      vStep?.verticalStepName?.toLowerCase().includes("collateral"),
  );
  const fields = collateralVerticalStep?.fields;
  if (!Array.isArray(fields)) return false;

  // Group filled collateral<N>... keys by their N. Collateral 1's field
  // keys are permanent (never deleted, see CollateralDetails.tsx's
  // removeCollateralFields) — once removed, its values are blanked but the
  // keys stay, so a deleted group must NOT block another, still-genuinely-
  // saved group (e.g. Collateral 2) from counting as saved.
  const filledKeyCountByGroup: Record<string, number> = {};
  for (const field of fields) {
    const key = Object.keys(field || {}).find(
      (k) => /^collateral\d+/i.test(k) && k.toLowerCase() !== "hascollateral",
    );
    if (!key) continue;
    const rawValue = (field as any)[key];
    const resolvedValue =
      rawValue && typeof rawValue === "object"
        ? (rawValue as any).value ?? (rawValue as any).label
        : rawValue;
    if (String(resolvedValue ?? "").trim() === "") continue;
    const groupNum = key.match(/^collateral(\d+)/i)?.[1] || "1";
    filledKeyCountByGroup[groupNum] = (filledKeyCountByGroup[groupNum] || 0) + 1;
  }
  console.log(filledKeyCountByGroup,"filledKeyCountByGroup")
  return Object.entries(filledKeyCountByGroup).some(([groupNum, count]) => {
    console.log(activeCollateralStatusByGroup,"activeCollateralStatusByGroup")
    if (count <= 1) return false;
    const activeStatus = activeCollateralStatusByGroup?.[groupNum];
    return activeStatus !== false;
  });
};

export const buildCollateralFormDataEntries = (
  allFields: Array<{ id?: any; name?: string; formFieldId?: any; fieldId?: any }>,
  currentValues: Record<string, any>,
  collateralNumber: number,
  includeHasCollateral: boolean = false,
): Array<{ formFieldId: any; fieldKey: string; fieldValue: string }> => {
  const resolveFieldId = resolveCollateralFieldId;

  const toNormalizedValue = (rawValue: any) => {
    if (rawValue && typeof rawValue === "object") {
      if ("value" in rawValue) return rawValue.value;
      if ("label" in rawValue) return rawValue.label;
      return rawValue;
    }
    return rawValue;
  };

  // "Has Collateral?" = No: send ONLY that answer, never any collateral<N>
  // field — Collateral 1's field keys are permanent (never deleted, see
  // CollateralDetails.tsx's removeCollateralFields), so without this
  // explicit short-circuit a stale/blank field could otherwise still slip
  // into the payload depending on how it happens to resolve elsewhere.
  const hasCollateralRaw = currentValues?.hasCollateral;
  const hasCollateralResolved = String(
    hasCollateralRaw && typeof hasCollateralRaw === "object"
      ? (hasCollateralRaw as any).value ?? (hasCollateralRaw as any).label ?? ""
      : hasCollateralRaw ?? "",
  ).trim();
  if (hasCollateralResolved.toLowerCase() === "no") {
    if (!includeHasCollateral) return [];
    const hasCollateralField = allFields.find(
      (field) =>
        String(field?.name || "").toLowerCase().replace(/[^a-z0-9]/g, "") ===
        "hascollateral",
    );
    const fieldId = hasCollateralField ? resolveFieldId(hasCollateralField) : undefined;
    if (!hasCollateralField?.name || fieldId === undefined || fieldId === null) return [];
    return [
      {
        formFieldId: fieldId,
        fieldKey: hasCollateralField.name,
        fieldValue: hasCollateralResolved,
      },
    ];
  }

  const collateralNumberFields = allFields.filter((field) => {
    const fieldId = resolveFieldId(field);
    if (!fieldId || !field?.name) return false;
    return fieldBelongsToCollateralNumber(field.name, collateralNumber);
  });

  // Only send fields relevant to the currently selected collateral type
  // (e.g. skip Property fields when Fixed Deposit is selected) — a stale
  // value left over from a previously selected type must never reach the API.
  const { base, coOwner } = getCollateralFieldsByGroup(
    collateralNumberFields,
    collateralNumber,
  );
  const relevantFields = [
    ...getVisibleCollateralBaseFields(base, currentValues),
    ...coOwner,
  ];

  // "Has Collateral?" (hasCollateral) is a standalone field, not part of any
  // numbered collateral group, so it's excluded from collateralNumberFields
  // above — but its answer still needs to reach the backend. The caller
  // decides which single collateral it rides along with (the first one
  // being saved, index 0 of whichever numbers are being saved this round —
  // not hardcoded to "1", since Collateral 1 specifically may have been
  // deleted while a later-numbered one still remains) so it's never sent
  // with more than one group's save and never silently dropped either.
  if (includeHasCollateral) {
    const hasCollateralField = allFields.find(
      (field) =>
        String(field?.name || "").toLowerCase().replace(/[^a-z0-9]/g, "") ===
        "hascollateral",
    );
    if (hasCollateralField?.name && !relevantFields.some((f) => f.name === hasCollateralField.name)) {
      relevantFields.push(hasCollateralField);
    }
  }

  return relevantFields
    .map((field) => {
      const rawValue = currentValues?.[field.name!];
      const normalizedValue = toNormalizedValue(rawValue);

      // create-collateral expects the collateral type's label (e.g. "Property"),
      // not its option value/id — every other field keeps sending its value.
      const isCollateralTypeField = /^collateral\d*type$/.test(
        normalizeCollateralFieldKey(field.name!),
      );
      const fieldValue = isCollateralTypeField
        ? String(
            mapCollateral().find(
              (opt: any) => String(opt.value) === String(normalizedValue),
            )?.label ?? normalizedValue ?? "",
          )
        : normalizedValue !== null && normalizedValue !== undefined
          ? String(normalizedValue)
          : "";

      return {
        formFieldId: resolveFieldId(field),
        fieldKey: field.name!,
        fieldValue,
      };
    })
    .filter((item) => item.fieldValue.trim() !== "");
};

export const resolveCollateralNumbersToSave = (
  pageType: string | undefined,
  selectedCollateralNumber: number,
  mergedFields: any[],
  currentValues: Record<string, any>,
): number[] => {
  // This used to return getCompleteCollateralNumbers(mergedFields,
  // currentValues) — every completed collateral, not just
  // selectedCollateralNumber — on the theory that SUMMARY needs to save
  // every completed collateral, not just whichever one the accordion
  // happens to have expanded. That's true, but it's no longer this
  // function's job: ReferenceCollateralDetails.tsx's own SUMMARY save
  // effect already loops over every present collateral number and calls
  // this (via onCollateralSaveAndNext) once per number. Resolving to every
  // complete number HERE too meant each of those per-number calls re-saved
  // every OTHER complete collateral as well — an N-collateral save fired
  // createCollateral N times per number, N² times in total (e.g. 4 calls
  // for 2 collaterals). Only the one actually requested is saved here now;
  // the outer loop is what covers "every completed collateral gets saved".
  return [selectedCollateralNumber];
};

// The backend used to send Reference and Collateral fields bundled into a
// single "Reference & Collateral Details" vertical step; it now sends them as
// two separate vertical steps ("Reference Details" / "Collateral Details").
// This predicate recognizes a vertical step as belonging to either shape, so
// callers can keep treating Reference+Collateral as one logical field group
// regardless of which shape the backend happens to return.
export const isReferenceCollateralVerticalStepLabel = (label: string): boolean => {
  const stepLabel = String(label || "");
  if (!stepLabel.trim()) return false;
  if (/reference\s*&\s*collateral|reference and collateral/i.test(stepLabel)) {
    return true;
  }
  const normalized = stepLabel.toLowerCase().replace(/[^a-z0-9]/g, "");
  return normalized === "referencedetails" || normalized === "collateraldetails";
};

// Collapses separate "Reference Details" / "Collateral Details" vertical
// steps (new backend shape) back into a single combined vertical step with
// merged fields, at the position of the first one encountered — so any code
// still indexing/counting vertical steps by position keeps working whether
// the backend sends them combined (old shape) or split (new shape).
export const mergeReferenceCollateralVerticalSteps = (verticalSteps: any[] = []): any[] => {
  const merged: any[] = [];
  const byName = new Map<string, any>();
  let templateStep: any = null;
  let insertedAt = -1;

  (verticalSteps || []).forEach((step: any) => {
    const label = step?.stepLabel || step?.verticalStepName || "";
    if (!isReferenceCollateralVerticalStepLabel(label)) {
      merged.push(step);
      return;
    }
    (step?.fields || []).forEach((field: any) => {
      if (!field?.name) return;
      byName.set(field.name, { ...byName.get(field.name), ...field });
    });
    if (!templateStep) {
      templateStep = step;
      insertedAt = merged.length;
      merged.push(step);
    }
  });

  if (templateStep && insertedAt !== -1) {
    merged[insertedAt] = { ...templateStep, fields: Array.from(byName.values()) };
  }

  return merged;
};

export const getMergedCollateralFieldDefinitions = (
  horizontalSteps: any[],
  propFields: any[] = [],
  horizontalStepLabel?: string,
): any[] => {
  const byName = new Map<string, any>();
  const addFields = (fieldList: any[]) => {
    (fieldList || []).forEach((field) => {
      if (!field?.name) return;
      byName.set(field.name, { ...byName.get(field.name), ...field });
    });
  };

  addFields(propFields);

  const stepsToScan =
    horizontalStepLabel && horizontalStepLabel.trim()
      ? (horizontalSteps || []).filter(
          (step) => step?.stepLabel === horizontalStepLabel,
        )
      : horizontalSteps || [];

  const scanTargets = stepsToScan.length > 0 ? stepsToScan : horizontalSteps || [];

  scanTargets.forEach((horizontalStep) => {
    (horizontalStep?.verticalSteps || []).forEach((verticalStep: any) => {
      if (isReferenceCollateralVerticalStepLabel(verticalStep?.stepLabel || "")) {
        addFields(verticalStep?.fields);
      }
    });
  });

  if (byName.size === 0) {
    scanTargets.forEach((horizontalStep) => {
      (horizontalStep?.verticalSteps || []).forEach((verticalStep: any) => {
        addFields(verticalStep?.fields);
      });
    });
  }

  return Array.from(byName.values());
};

export const isCoOwnerCollateralNameField = (fieldName: string): boolean =>
  /^coOwnerCollateral/i.test(String(fieldName || "")) && /Name$/i.test(String(fieldName || ""));

export const parseCoOwnerCollateralNameField = (
  fieldName: string,
): { collateralNumber: number; ownerIndex: number } | null => {
  const normalized = String(fieldName || "");

  const underscoreMatch = normalized.match(/^coOwnerCollateral(\d+)_(\d+)Name$/i);
  if (underscoreMatch) {
    return {
      collateralNumber: Number(underscoreMatch[1]),
      ownerIndex: Number(underscoreMatch[2]),
    };
  }

  const simpleMatch = normalized.match(/^coOwnerCollateral(\d+)Name$/i);
  if (simpleMatch) {
    return {
      collateralNumber: Number(simpleMatch[1]),
      ownerIndex: 1,
    };
  }

  return null;
};

export const getCollateralNumberFromCoOwnerField = (fieldName: string): number => {
  const nameParsed = parseCoOwnerCollateralNameField(fieldName);
  if (nameParsed) return nameParsed.collateralNumber;

  const normalized = String(fieldName || "");
  const underscoreMatch = normalized.match(/^coOwnerCollateral(\d+)_(\d+)/i);
  if (underscoreMatch) return Number(underscoreMatch[1]);

  // No "compact two-digit-group" match here on purpose: a field like
  // "coOwnerCollateral12OwnershipPercentage" (collateral 12's default,
  // implicit-owner-1 co-owner field — created by addCollateralFields'
  // renameToNext cloning collateral 1's compact-format template fields) is
  // genuinely ambiguous to split into two digit groups. A previous version
  // tried /^coOwnerCollateral(\d+)(\d+)[A-Za-z]/, which greedily matches
  // then backtracks to the *shortest* valid first group — for "12" that
  // resolves to collateralNumber=1, ownerIndex=2, silently misfiling
  // collateral 12's co-owner fields under collateral 1. The plain
  // simpleMatch below already captures the full digit run correctly for
  // both single- and multi-digit collateral numbers (compact fields are
  // always the default/owner-1 co-owner, never an explicit later index).
  const simpleMatch = normalized.match(/^coOwnerCollateral(\d+)/i);
  if (simpleMatch) return Number(simpleMatch[1]);

  if (
    /^coOwnerCollateral/i.test(normalized) &&
    !/^coOwnerCollateral\d+/i.test(normalized)
  ) {
    return 1;
  }

  return 1;
};

export const normalizeCoOwnerPersonName = (value: any): string => {
  if (value && typeof value === "object" && "value" in value) {
    return String(value.value ?? "").trim();
  }
  if (value && typeof value === "object" && "label" in value) {
    return String(value.label ?? "").trim();
  }
  return String(value ?? "").trim();
};

export const CO_OWNER_COLLATERAL_NAME_REGEX =
  /^coOwnerCollateral(\d+)(?:_\d+|\d+)?Name$/i;

export const isCollateralFieldValueFilled = (value: any): boolean => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "number") return true;
  if (typeof value === "boolean") return true;
  if (value && typeof value === "object") {
    if ("value" in value) return String(value.value ?? "").trim() !== "";
    return Object.keys(value).length > 0;
  }
  return String(value ?? "").trim() !== "";
};

const collateralFieldHasToken = (field: any, tokens: string[]) => {
  const normalizedName = normalizeCollateralFieldKey(field?.name);
  const normalizedLabel = normalizeCollateralFieldKey(field?.label);
  return tokens.some(
    (token) =>
      normalizedName.includes(token) || normalizedLabel.includes(token),
  );
};

export const getCollateralNumbersFromFields = (fields: any[]): number[] => {
  const nums = new Set<number>();
  (fields || []).forEach((field) => {
    const collateralNumber = getCollateralNumberFromFieldName(field?.name);
    if (collateralNumber) nums.add(collateralNumber);
  });
  if (!nums.size) nums.add(1);
  return Array.from(nums).sort((a, b) => a - b);
};

// "Has Collateral?" should only ride along with the FIRST collateral's save —
// the lowest-numbered group that actually has data (Collateral 1's keys are
// permanent, so it may be blank after removal while Collateral 2 remains).
export const isFirstCollateralWithData = (
  fields: any[],
  values: Record<string, any>,
  collateralNumber: number,
): boolean => {
  const hasValue = (raw: any) => {
    if (raw === null || raw === undefined) return false;
    if (typeof raw === "object") {
      return String(raw?.value ?? raw?.label ?? "").trim() !== "";
    }
    return String(raw).trim() !== "";
  };
  const numbersWithData = getCollateralNumbersFromFields(fields).filter((n) =>
    (fields || []).some(
      (field: any) =>
        !/^coOwnerCollateral/i.test(String(field?.name || "")) &&
        getCollateralNumberFromFieldName(field?.name) === n &&
        hasValue(values?.[field?.name]),
    ),
  );
  if (numbersWithData.length === 0) return true;
  return collateralNumber === numbersWithData[0];
};

export const getCollateralFieldsByGroup = (
  fields: any[],
  collateralNumber: number,
) => {
  const base = (fields || []).filter((field) => {
    const resolvedNumber = getCollateralNumberFromFieldName(field?.name);
    return (
      resolvedNumber === collateralNumber &&
      !/^coOwnerCollateral/i.test(String(field?.name || ""))
    );
  });

  const coOwner = (fields || []).filter((field) => {
    const resolvedNumber = getCollateralNumberFromFieldName(field?.name);
    return (
      resolvedNumber === collateralNumber &&
      /^coOwnerCollateral/i.test(String(field?.name || ""))
    );
  });

  return { base, coOwner };
};

export const getCollateralModeFromFields = (
  baseFields: any[],
  formValues: Record<string, any>,
): "fixed" | "savings" | "property" | null => {
  const typeField = (baseFields || []).find((field) => {
    const normalized = normalizeCollateralFieldKey(field?.name);
    return (
      /^collateral\d*type$/.test(normalized) ||
      normalizeCollateralFieldKey(field?.label).includes("collateraltype")
    );
  });

  if (!typeField) return null;

  const raw = formValues?.[typeField.name];
  const rawValue =
    raw && typeof raw === "object" && "value" in raw ? raw.value : raw;
  const rawLabel =
    raw && typeof raw === "object" && "label" in raw ? raw.label : raw;
  const normalized = normalizeCollateralFieldKey(String(rawLabel || rawValue));
  const normalizedValue = String(rawValue ?? "").trim();

  if (
    normalizedValue === "307" ||
    normalized.includes("fixed") ||
    normalized.includes("fd")
  ) {
    return "fixed";
  }
  if (normalizedValue === "309" || normalized.includes("saving")) {
    return "savings";
  }
  if (normalizedValue === "308" || normalized.includes("property")) {
    return "property";
  }
  return null;
};

export const getVisibleCollateralBaseFields = (
  baseFields: any[],
  formValues: Record<string, any>,
) => {
  const mode = getCollateralModeFromFields(baseFields, formValues);
  if (!mode) {
    // "Has Collateral?" = No: Collateral 1's field keys are permanent (never
    // deleted on removal — see CollateralDetails.tsx's removeCollateralFields),
    // so a blank Type here no longer means "no fields exist yet" the way it
    // used to. Returning every base field as "visible" made each of them
    // (FdHolderName, AccountNumber, AddressLine1, etc. — forced required:true
    // by ReferenceCollateralDetails) fail required-field validation via
    // getCollateralFieldError even though there's nothing to fill in, which
    // silently blocked the SUMMARY save. None of them are relevant when No
    // is selected, so return nothing instead.
    const rawHasCollateral = formValues?.hasCollateral;
    const hasCollateralAnswer = String(
      rawHasCollateral && typeof rawHasCollateral === "object"
        ? (rawHasCollateral as any).value ?? (rawHasCollateral as any).label
        : rawHasCollateral ?? "",
    ).trim().toLowerCase();
    if (hasCollateralAnswer === "no") return [];
    return baseFields || [];
  }

  const commonTokens = ["collateraltype", "collateralvalue"];
  const isTypeOrValueField = (field: any) => {
    const normalized = normalizeCollateralFieldKey(field?.name);
    return (
      /^collateral\d*type$/.test(normalized) ||
      /^collateral\d*value$/.test(normalized) ||
      collateralFieldHasToken(field, commonTokens)
    );
  };

  const tokenMap: Record<"fixed" | "savings" | "property", string[]> = {
    fixed: ["fdholdername", "fdnumber"],
    savings: ["holdername", "accountnumber"],
    property: [
      "unitprice",
      "noofunits",
      "totalvalue",
      "propertypename",
      "propertysubtypename",
      "addresstype",
      "addressline1",
      "addressline2",
      "landmark",
      "area",
      "pincode",
      "city",
      "state",
      "country",
    ],
  };
  return (baseFields || []).filter((field: any) => {
    // 1. Keep standard type/value fields
    if (isTypeOrValueField(field)) {
      return true;
    }

    const rawKey = (field?.key || field?.name || field?.token || "").toLowerCase();

    // 2. Extra validation for savings mode: reject FD fields (fdholdername, fdnumber, etc.)
    if (mode === "savings" && rawKey.includes("fd")) {
      return false;
    }

    // 3. Otherwise proceed with token check
    return collateralFieldHasToken(field, tokenMap[mode]);
  });
};

// Any co-owner field's (Name/OwnershipPercentage/PhoneNumber) own owner
// index, parsed straight from its "_N" suffix — or 1 for the un-suffixed
// default (owner 1's fields never carry a "_1"). Unlike
// parseCoOwnerCollateralNameField, this isn't limited to Name fields.
export const getOwnerIndexFromCoOwnerField = (fieldName: any): number => {
  const normalized = String(fieldName || "");
  const underscoreMatch = normalized.match(/^coOwnerCollateral\d+_(\d+)/i);
  return underscoreMatch ? Number(underscoreMatch[1]) : 1;
};

export const splitCoOwnerCollateralSections = (coOwnerFields: any[]) => {
  if (!Array.isArray(coOwnerFields) || coOwnerFields.length === 0) return [];

  // Bucket by each field's OWN owner index rather than by scan order. Scan-
  // order grouping (start a new section on the next Name field, sweep
  // everything after it into that section) assumed fields always arrive
  // interleaved as [Name1,Percentage1,Phone1,Name2,Percentage2,Phone2,...]
  // — true for fields added via "Add More" this session, but not
  // guaranteed for fields coming back from a fresh fetch (ordered by the
  // backend's own fieldOrder, not owner grouping). When that assumption
  // broke, one owner's Name field landed alone in its own section while
  // its Percentage/Phone (and everyone after it) got swept into a LATER
  // owner's section — showing one owner's value under a different owner's
  // heading. Bucketing by each field's own parsed index is immune to
  // array order entirely.
  const sectionsByOwnerIndex = new Map<number, any[]>();
  coOwnerFields.forEach((field) => {
    const ownerIndex = getOwnerIndexFromCoOwnerField(field?.name);
    sectionsByOwnerIndex.set(ownerIndex, [
      ...(sectionsByOwnerIndex.get(ownerIndex) || []),
      field,
    ]);
  });

  return Array.from(sectionsByOwnerIndex.keys())
    .sort((a, b) => a - b)
    .map((ownerIndex) => sectionsByOwnerIndex.get(ownerIndex) as any[]);
};

export const isCollateralSectionComplete = (
  allFields: any[],
  formValues: Record<string, any>,
  collateralNumber: number,
): boolean => {
  const { base, coOwner } = getCollateralFieldsByGroup(allFields, collateralNumber);
  const visibleBase = getVisibleCollateralBaseFields(base, formValues);
  const coOwnerSections = splitCoOwnerCollateralSections(coOwner);
  const visibleCoOwner = coOwnerSections.flat();
  const allSectionFields = [...visibleBase, ...visibleCoOwner];
  // Collateral Type only needs to be picked once the applicant has said
  // they're adding collateral — don't block section completion on it
  // beforehand (e.g. while still deciding, or having answered "No").
  const isCollateralTypeField = (field: any) =>
    /^collateral\d*Type$/i.test(String(field?.name || ""));
  const requiredFields = allSectionFields.filter(
    (field) =>
      field?.required !== false &&
      field?.type !== "hidden" &&
      !(isCollateralTypeField(field) && formValues?.collateral !== "Yes"),
  );
  if (requiredFields.length === 0) return false;
  return requiredFields.every((field) =>
    isCollateralFieldValueFilled(formValues?.[field?.name]),
  );
};

export const getCompleteCollateralNumbers = (
  allFields: any[],
  formValues: Record<string, any>,
): number[] =>
  getCollateralNumbersFromFields(allFields).filter((collateralNumber) =>
    isCollateralSectionComplete(allFields, formValues, collateralNumber),
  );

// ─── Reference & Collateral: single source of truth for custom validation ───
// Pulled out of ReferenceCollateralDetails.tsx so this exact logic can be fed
// into Formik's `validate` prop (alongside `validationSchema`) instead of only
// being applied imperatively via setFieldError on a Save & Next click. Formik
// merges `validate` + `validationSchema` results into ONE atomic errors object
// on every validation pass, so these rules can never be dropped by a later
// validateOnChange revalidation the way an imperative setFieldError was.
const normalizeReferenceCollateralFieldKey = (name: any) =>
  String(name || "").toLowerCase().replace(/[^a-z0-9]/g, "");

const REFERENCE_COLLATERAL_NAME_REGEX = /^[a-zA-Z ]+$/;
const REFERENCE_MOBILE_REGEX = /^(?!.*^(.)\1+$)[6-9]\d{9}$/;
const REFERENCE_EMAIL_REGEX = JOURNEY_EMAIL_REGEX;
// Reference 1 / Reference 2 Address Line 1 & 2: alphabets, numbers and space only.
const REFERENCE_ADDRESS_LINE_REGEX = /^[a-zA-Z0-9 ]*$/;

const getReferenceFieldError = (field: any, rawValue: any): string | undefined => {
  const name = String(field?.name || "");
  const value = String(rawValue ?? "").trim();
  const isRequired = field?.required !== false;

  const isReferenceEmailFieldName = /^basicReference\d+(Email|EmailID)$/.test(name);

  if (
    !value &&
    !(name?.includes("AddressLine2") || name?.includes("Locality") || name?.includes("Area"))
  ) {
    return isRequired ? getReferenceRequiredMessage(name, field?.label) : undefined;
  }

  if (/^basicReference\d+(FirstName|LastName)$/.test(name)) {
    if (value.length > 25) return "Maximum 25 characters allowed";
    if (!REFERENCE_COLLATERAL_NAME_REGEX.test(value)) return "Only letters and spaces are allowed";
  } else if (isReferenceEmailFieldName) {
    if (value.length > 40) return "Maximum 40 characters allowed";
    if (!REFERENCE_EMAIL_REGEX.test(value)) return "Enter a valid email address";
  } else if (/^basicReference\d+(PhoneNumber|Mobile)$/.test(name)) {
    if (!REFERENCE_MOBILE_REGEX.test(value)) return "Enter a valid 10-digit mobile number";
  } else if (/^addressReference\d+AddressLine1$/.test(name)) {
    if (value.length > 50) return "Maximum 50 characters allowed";
    if (!REFERENCE_ADDRESS_LINE_REGEX.test(value)) {
      return "Only alphabets, numbers and space are allowed";
    }
  } else if (/^addressReference\d+AddressLine2$/.test(name)) {
    // Only checked when the user actually filled something in — AddressLine2
    // stays optional (see the early empty-value skip above).
    if (!REFERENCE_ADDRESS_LINE_REGEX.test(value)) {
      return "Only alphabets, numbers and space are allowed";
    }
  } else if (/^addressReference\d+Locality$/.test(name)) {
    // Locality is optional — the empty-value skip above lets a blank through,
    // so this format rule only ever runs once the user has typed something.
    if (value.length > 50) return "Maximum 50 characters allowed";
    if (!REFERENCE_ADDRESS_LINE_REGEX.test(value)) {
      return "Only alphabets, numbers and space are allowed";
    }
  } else if (/^addressReference\d+Area$/.test(name)) {
    // Area is optional — the empty-value skip above lets a blank through,
    // so this format rule only ever runs once the user has typed something.
    if (value.length > 50) return "Maximum 50 characters allowed";
    if (!REFERENCE_ADDRESS_LINE_REGEX.test(value)) {
      return "Only alphabets, numbers and space are allowed";
    }
  } else if (/^addressReference\d+Landmark$/.test(name)) {
    if (value.length > 50) return "Maximum 50 characters allowed";
    if (!REFERENCE_ADDRESS_LINE_REGEX.test(value)) {
      return "Only alphabets, numbers and space are allowed";
    }
  } else if (/^addressReference\d+Pincode$/.test(name)) {
    if (!/^\d{6}$/.test(value)) return "Please enter a valid 6-digit pincode.";
  }
  return undefined;
};

const REFERENCE_REQUIRED_MESSAGES: [RegExp, string][] = [
  [/^basicReference\d+FirstName$/, "Please enter the reference's first name."],
  [/^basicReference\d+LastName$/, "Please enter the reference's last name."],
  [/^basicReference\d+(Email|EmailID)$/, "Please enter the reference's email address."],
  [/^basicReference\d+(PhoneNumber|Mobile)$/, "Please enter the reference's mobile number."],
  [/^addressReference\d+AddressLine1$/, "Please enter address line 1."],
  [/^addressReference\d+Landmark$/, "Please enter the landmark."],
  [/^addressReference\d+Pincode$/, "Please enter a valid 6-digit pincode."],
  [/^addressReference\d+City$/, "Please select or enter the city."],
  [/^addressReference\d+State$/, "Please select or enter the state."],
  [/^addressReference\d+Country$/, "Please select the country."],
];

const getReferenceRequiredMessage = (name: string, label?: string): string =>
  REFERENCE_REQUIRED_MESSAGES.find(([pattern]) => pattern.test(name))?.[1] ??
  `${label || name} is required`;

const getReferenceUniquenessErrors = (
  referenceFields: any[],
  values: Record<string, any>,
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const findReferenceFieldName = (n: number, suffixPattern: RegExp): string | undefined =>
    referenceFields.find((f: any) => {
      const name = String(f?.name || "");
      return name.startsWith(`basicReference${n}`) && suffixPattern.test(name);
    })?.name;

  const getReferenceFullName = (n: number): string => {
    const firstName = values?.[findReferenceFieldName(n, /FirstName$/) || ""];
    const lastName = values?.[findReferenceFieldName(n, /LastName$/) || ""];
    return `${String(firstName ?? "").trim()} ${String(lastName ?? "").trim()}`
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  };

  const getReferenceContactField = (n: number, suffixPattern: RegExp) => {
    const name = findReferenceFieldName(n, suffixPattern);
    return { name, value: String(values?.[name || ""] ?? "").trim() };
  };

  const [n1, n2] = [1, 2];

  const fullName1 = getReferenceFullName(n1);
  const fullName2 = getReferenceFullName(n2);
  if (fullName1 && fullName2 && fullName1 === fullName2) {
    const message = "A reference with this name already exists. Please enter a different name.";
    [findReferenceFieldName(n1, /FirstName$/), findReferenceFieldName(n1, /LastName$/),
     findReferenceFieldName(n2, /FirstName$/), findReferenceFieldName(n2, /LastName$/)]
      .forEach((name) => { if (name) errors[name] = message; });
  }

  const email1 = getReferenceContactField(n1, /(Email|EmailID)$/);
  const email2 = getReferenceContactField(n2, /(Email|EmailID)$/);
  if (email1.value && email2.value && email1.value.toLowerCase() === email2.value.toLowerCase()) {
    const message =
      "This email address has already been used for another reference on your application. Please enter a different email address.";
    if (email1.name) errors[email1.name] = message;
    if (email2.name) errors[email2.name] = message;
  }

  const mobile1 = getReferenceContactField(n1, /(PhoneNumber|Mobile)$/);
  const mobile2 = getReferenceContactField(n2, /(PhoneNumber|Mobile)$/);
  if (mobile1.value && mobile2.value && mobile1.value === mobile2.value) {
    const message =
      "This mobile number has already been used in this application. Please enter a different mobile number for this reference.";
    if (mobile1.name) errors[mobile1.name] = message;
    if (mobile2.name) errors[mobile2.name] = message;
  }

  return errors;
};

const COLLATERAL_NAME_REGEX = /^[a-zA-Z ]+$/;

const getCollateralFieldError = (
  field: any,
  rawValue: any,
  values: Record<string, any>,
): string | undefined => {
  const name = String(field?.name || "");

  // Auto-computed (Total Value) / auto-filled-by-pincode (City/State/Country) fields
  // aren't user-required-input — never block a save on these.
  if (/^collateral\d*(TotalValue|City|State|Country)$/i.test(name)) {
    return undefined;
  }

  const resolvedRawValue =
    rawValue && typeof rawValue === "object" && "value" in rawValue
      ? (rawValue as any).value
      : rawValue;
  const value = String(resolvedRawValue ?? "").trim();

  // Collateral Type only needs to be picked once the applicant has actually
  // said they're adding collateral — don't block Save on it beforehand.
  const isCollateralTypeField = /^collateral\d*Type$/i.test(name);
  const isRequired =
    isCollateralTypeField && values?.collateral !== "Yes"
      ? false
      : field?.required !== false;

  if (!value && !(/^collateral\d*Value$/i.test(name))) {
    return isRequired ? `${field?.label || name} is required` : undefined;
  }

  if (/^collateral\d*(Fd)?HolderName$/i.test(name)) {
    if (value.length > 50) return "Maximum 50 characters allowed";
    if (!COLLATERAL_NAME_REGEX.test(value)) return "Only letters and spaces are allowed";
  } else if (/^collateral\d*FdNumber$/i.test(name)) {
    if (!/^[0-9]+$/.test(value)) return "Only numbers are allowed";
  } else if (/^collateral\d*Value$/i.test(name)) {
    const numeric = Number(value.replace(/,/g, ""));
    if (Number.isNaN(numeric) || numeric < 0) return "Enter a valid amount";
  } else if (/^collateral\d*NoOfUnits$/i.test(name)) {
    if (!/^[0-9]+$/.test(value)) return "Only numbers are allowed";
  } else if (/^collateral\d*UnitPrice$/i.test(name)) {
    const numeric = Number(value.replace(/,/g, ""));
    if (Number.isNaN(numeric) || numeric < 0) return "Enter a valid amount";
  } else if (/^collateral\d*AccountNumber$/i.test(name)) {
    if (!/^[0-9]+$/.test(value)) return "Only numbers are allowed";
  } else if (/^collateral\d*(AddressLine1|Landmark)$/i.test(name)) {
    if (value.length > 50) return "Maximum 50 characters allowed";
  } else if (/^collateral\d*Area$/i.test(name)) {
    if (value.length > 255) return "Maximum 255 characters allowed";
  } else if (/^collateral\d*Pincode$/i.test(name)) {
    if (!/^\d{6}$/.test(value)) return "Enter a valid 6-digit pincode";
  }
  return undefined;
};

const resolveReferenceCollateralValue = (raw: any): string => {
  if (raw && typeof raw === "object" && "value" in raw) {
    return String((raw as any).value ?? "").trim();
  }
  return String(raw ?? "").trim();
};

const getCollateralRequiredFieldErrorsForGroup = (
  collateralFields: any[],
  collateralNumber: number,
  values: Record<string, any>,
): Record<string, string> => {
  const errors: Record<string, string> = {};
  // Collateral 1's field keys are permanent (never deleted on removal — see
  // CollateralDetails.tsx's removeCollateralFields), so once "Has
  // Collateral?" = No they stay present but blank. Without this check, a
  // blank-but-present Collateral Type would keep failing validation (e.g.
  // blocking the SUMMARY save) even though the applicant said No.
  if (collateralNumber === 1) {
    const rawHasCollateral = values?.hasCollateral;
    const hasCollateralAnswer = String(
      rawHasCollateral && typeof rawHasCollateral === "object"
        ? (rawHasCollateral as any).value ?? (rawHasCollateral as any).label
        : rawHasCollateral ?? "",
    ).trim().toLowerCase();
    if (hasCollateralAnswer === "no") return errors;
  }
  const { base, coOwner } = getCollateralFieldsByGroup(collateralFields, collateralNumber);

  const visibleBase = getVisibleCollateralBaseFields(base, values).filter(
    (f: any) => !f?.isRemoved && f?.type !== "hidden",
  );
  const visibleCoOwner = splitCoOwnerCollateralSections(coOwner).flat().filter(
    (f: any) => !f?.isRemoved && f?.type !== "hidden",
  );

  const isEmpty = (name: string) => !resolveReferenceCollateralValue(values?.[name]);
  const findField = (fieldsList: any[], pattern: RegExp) =>
    fieldsList.find((f: any) => pattern.test(String(f?.name || "")));

  const requireByPattern = (
    fieldsList: any[],
    pattern: RegExp,
    label: string,
    errMsg?: string,
  ) => {
    const field = findField(fieldsList, pattern);
    if (field?.name && isEmpty(field.name)) {
      errors[field.name] = errMsg ? errMsg : `${field.label || label} is required`;
    }
  };

  const typeField = findField(base, /Type$/i);

  if (typeField?.name && isEmpty(typeField.name)) {
    errors[typeField.name] = `${typeField.label || "Collateral Type"} is required`;
  }

  // The Type dropdown stores codes ("307" FD / "309" Savings / "308" Property),
  // so resolve the mode from the code rather than matching on the label text.
  const collateralMode = getCollateralModeFromFields(base, values);
  const isFdOrSaving = collateralMode === "fixed" || collateralMode === "savings";
  const isProperty = collateralMode === "property";

  if (isFdOrSaving) {
    requireByPattern(visibleBase, /(?<!Total)Value$/i, "Collateral Value");
    requireByPattern(visibleBase, /(Fd)?HolderName$/i, "Name FD Holder");
    requireByPattern(visibleBase, /FdNumber$/i, "FD Number");
  } else if (isProperty) {
    requireByPattern(visibleBase, /(?<!Total)Value$/i, "Collateral Value");
    requireByPattern(visibleBase, /UnitPrice$/i, "Per Price Unit", "Per Price Unit minimum value should be 0");
    requireByPattern(visibleBase, /NoOfUnits$/i, "Number of Units", "Number of Units minimum value should be 0");
    requireByPattern(visibleBase, /TotalValue$/i, "Total Value");
    requireByPattern(visibleBase, /PropertypeName$/i, "Property Type");
    requireByPattern(visibleBase, /PropertySubTypeName$/i, "Property Sub Type");
    requireByPattern(visibleBase, /AddressType$/i, "Address Type");
    requireByPattern(visibleBase, /AddressLine1$/i, "Address Line 1");
    // Address Line 2 is always optional, regardless of collateral type.
    requireByPattern(visibleBase, /Pincode$/i, "Pincode");
    requireByPattern(visibleBase, /City$/i, "City");
    requireByPattern(visibleBase, /State$/i, "State");
    requireByPattern(visibleBase, /Country$/i, "Country");
  }

  const coOwnerNameField = visibleCoOwner.find((f: any) => {
    const n = String(f?.name || "").toLowerCase();
    return (
      n.includes("name") &&
      !n.includes("percentage") &&
      !n.includes("phone") &&
      !n.includes("mobile")
    );
  });

  const coOwnerNameHasValue = !!coOwnerNameField?.name && !isEmpty(coOwnerNameField.name);

  if (coOwnerNameHasValue) {
    requireByPattern(visibleCoOwner, /(Ownership)?Percentage$/i, "Ownership Percentage");
    requireByPattern(visibleCoOwner, /(PhoneNumber|Mobile)$/i, "Phone Number");
  }

  return errors;
};

// Every Co-Owner section whose Name has been filled in must contribute an
// Ownership Percentage. Each individual share can be anywhere from 0 to 100,
// and the running total across all filled-in co-owners for this collateral
// must never exceed 100 — checked as soon as it's known to be over, without
// waiting for every co-owner section to be filled in first.
const getCoOwnerPercentageTotalErrorsForGroup = (
  collateralFields: any[],
  collateralNumber: number,
  values: Record<string, any>,
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const { coOwner } = getCollateralFieldsByGroup(collateralFields, collateralNumber);
  const sections = splitCoOwnerCollateralSections(coOwner)
    .map((section) => section.filter((f: any) => !f?.isRemoved && f?.type !== "hidden"))
    .filter((section) => section.length > 0);

  if (sections.length === 0) return errors;

  const percentageFields: any[] = [];
  let total = 0;

  sections.forEach((section: any[]) => {
    const nameField = section.find((f: any) => {
      const n = String(f?.name || "").toLowerCase();
      return (
        n.includes("name") &&
        !n.includes("percentage") &&
        !n.includes("phone") &&
        !n.includes("mobile")
      );
    });
    const percentageField = section.find((f: any) =>
      /(Ownership)?Percentage$/i.test(String(f?.name || "")),
    );
    if (!percentageField?.name) return;

    const nameHasValue = !!nameField?.name && !!resolveReferenceCollateralValue(values?.[nameField.name]);
    if (!nameHasValue) return;

    percentageFields.push(percentageField);
    const rawPercentage = resolveReferenceCollateralValue(values?.[percentageField.name]);
    if (rawPercentage === "") return; // required-check above already covers the empty case

    const numeric = Number(rawPercentage);
    if (Number.isNaN(numeric)) return; // format-check above already covers this

    total += numeric;
  });

  if (percentageFields.length === 0) return errors;

  if (total > 100) {
    const message = "Total ownership cannot exceed 100%. Please check and re-enter the details.";
    percentageFields.forEach((field: any) => {
      errors[field.name] = message;
    });
  }

  return errors;
};

// Shared by the FD Number / Account Number uniqueness checks below: flags
// every field matching `fieldNamePattern` whose value is repeated across
// collateral groups (an applicant can add several collaterals of the same
// type, but pledging the same FD/account twice isn't a real second one).
// Checked across ALL collateral numbers at once (not per-group, unlike
// getCollateralRequiredFieldErrorsForGroup/getCoOwnerPercentageTotalErrorsForGroup
// above) since a duplicate is only visible when comparing group N against
// every other group.
const getCollateralFieldUniquenessErrors = (
  collateralFields: any[],
  values: Record<string, any>,
  fieldNamePattern: RegExp,
  message: string,
): Record<string, string> => {
  const errors: Record<string, string> = {};
  const entries = (collateralFields || [])
    .filter((f: any) => fieldNamePattern.test(String(f?.name || "")))
    .map((f: any) => ({
      name: String(f?.name || ""),
      value: resolveReferenceCollateralValue(values?.[f?.name]),
    }))
    .filter((entry) => entry.name && entry.value);

  const namesByValue = new Map<string, string[]>();
  entries.forEach(({ name, value }) => {
    const key = value.toLowerCase();
    namesByValue.set(key, [...(namesByValue.get(key) || []), name]);
  });

  namesByValue.forEach((names) => {
    if (names.length > 1) {
      names.forEach((name) => {
        errors[name] = message;
      });
    }
  });

  return errors;
};

// Maps the collateral save API's duplicate-account errors (e.g. "Savings
// Collateral With AccountNumber Already Exist For The Application") to the
// customer-facing copy; any other error passes through unchanged.
export const getCollateralSaveErrorMessage = (error: any): string => {
  const message = String(
    error?.response?.data?.message || error?.message || "Unable to save Collateral details.",
  );
  if (/already\s*exist/i.test(message)) {
    if (/saving/i.test(message)) {
      return "This account number is already listed as savings collateral for this application.";
    }
    if (/\bfd\b|fixed\s*deposit/i.test(message)) {
      return "This FD account number is already listed as collateral on this application.";
    }
  }
  return message;
};

const getCollateralFdNumberUniquenessErrors = (
  collateralFields: any[],
  values: Record<string, any>,
): Record<string, string> =>
  getCollateralFieldUniquenessErrors(
    collateralFields,
    values,
    /^collateral\d*FdNumber$/i,
    "This FD account number is already listed as collateral on this application.",
  );

const getCollateralAccountNumberUniquenessErrors = (
  collateralFields: any[],
  values: Record<string, any>,
): Record<string, string> =>
  getCollateralFieldUniquenessErrors(
    collateralFields,
    values,
    /^collateral\d*AccountNumber$/i,
    "This account number is already listed as savings collateral for this application.",
  );

/**
 * Every custom Reference & Collateral validation rule that isn't expressible
 * (or isn't currently expressed) in the Yup validationSchema — required-if,
 * format, cross-reference uniqueness, and co-owner percentage total. Feed the
 * combined step field list (Reference + Collateral) and current form values;
 * used both as Formik's `validate` prop (so these rules are always part of
 * the same validation pass as the schema, with no separate reapply step) and
 * imperatively on Save & Next (to know whether to block navigation).
 */
export const getReferenceCollateralValidationErrors = (
  allFields: any[],
  values: Record<string, any>,
): Record<string, string> => {
  const referenceFields = (allFields || []).filter((f: any) => {
    const n = normalizeReferenceCollateralFieldKey(f?.name);
    return n.startsWith("basicreference") || n.startsWith("addressreference");
  });
  const collateralFields = (allFields || []).filter((f: any) => {
    const n = normalizeReferenceCollateralFieldKey(f?.name);
    return n.startsWith("collateral") || n.startsWith("coownercollateral");
  });

  const errors: Record<string, string> = {};
  Object.assign(errors, getCollateralFdNumberUniquenessErrors(collateralFields, values));
  Object.assign(errors, getCollateralAccountNumberUniquenessErrors(collateralFields, values));

  const visibleReferenceFields = referenceFields.filter(
    (f: any) => !f?.isRemoved && f?.type !== "hidden",
  );
  visibleReferenceFields.forEach((f: any) => {
    if (!f?.name) return;
    const message = getReferenceFieldError(f, values?.[f.name]);
    if (message) errors[f.name] = message;
  });
  Object.assign(errors, getReferenceUniquenessErrors(referenceFields, values));

  getCollateralNumbersFromFields(collateralFields).forEach((collateralNumber) => {
    const { base, coOwner } = getCollateralFieldsByGroup(collateralFields, collateralNumber);
    const visibleBase = getVisibleCollateralBaseFields(base, values).filter(
      (f: any) => !f?.isRemoved && f?.type !== "hidden",
    );
    const visibleCoOwner = splitCoOwnerCollateralSections(coOwner).flat();
    [...visibleBase, ...visibleCoOwner].forEach((f: any) => {
      if (!f?.name) return;
      const message = getCollateralFieldError(f, values?.[f.name], values);
      if (message) errors[f.name] = message;
    });

    Object.assign(errors, getCollateralRequiredFieldErrorsForGroup(collateralFields, collateralNumber, values));
    Object.assign(errors, getCoOwnerPercentageTotalErrorsForGroup(collateralFields, collateralNumber, values));
  });

  return errors;
};

// The collateral step's Formik only holds that step's own fields, so a
// co-applicant added elsewhere (e.g. the extended journey's Co-Applicant
// Additional Details) may only exist in Redux formData. Fill applicant /
// co-applicant name & phone keys from there when the form doesn't have them.
const withApplicantNameValues = (
  formValues: Record<string, any>,
): Record<string, any> => {
  const reduxFormData = (store.getState() as any)?.stepper?.formData || {};
  const merged: Record<string, any> = { ...(formValues || {}) };
  Object.keys(reduxFormData).forEach((key) => {
    const isNameOrPhoneKey =
      /^basicCoApplicant\d+(FirstName|LastName|PhoneNumber)$/.test(key) ||
      /^(firstName|lastName|studentDetailsFirstName|studentDetailsLastName|phone_number|studentDetailsPhone_number|mobileNumber)$/.test(key);
    if (!isNameOrPhoneKey) return;
    const current = merged[key];
    if (current === undefined || current === null || current === "") {
      merged[key] = reduxFormData[key];
    }
  });
  return merged;
};

export const buildCoOwnerNameOptions = (
  rawFormValues: Record<string, any>,
): Array<{ value: string; label: string }> => {
  const formValues = withApplicantNameValues(rawFormValues);
  const mainFirst =
    formValues?.firstName || formValues?.studentDetailsFirstName || "";
  const mainLast = formValues?.lastName || formValues?.studentDetailsLastName || "";
  const mainName = [mainFirst, mainLast].filter(Boolean).join(" ");
  const nameOptions: Array<{ value: string; label: string }> = [];
  if (mainName) nameOptions.push({ value: mainName, label: mainName });

  for (let ci = 1; ci <= 10; ci++) {
    const coFirst = formValues?.[`basicCoApplicant${ci}FirstName`];
    if (!coFirst) continue;
    const coLast = formValues?.[`basicCoApplicant${ci}LastName`] || "";
    const coName = [coFirst, coLast].filter(Boolean).join(" ");
    if (coName) nameOptions.push({ value: coName, label: coName });
  }

  return nameOptions;
};

export const getSelectedCoOwnerNamesForCollateral = (
  formValues: Record<string, any>,
  collateralNumber: number,
  excludeFieldName?: string,
): string[] =>
  Object.keys(formValues || {})
    .filter((key) => {
      if (excludeFieldName && key === excludeFieldName) return false;
      if (!isCoOwnerCollateralNameField(key)) return false;
      return getCollateralNumberFromCoOwnerField(key) === collateralNumber;
    })
    .map((key) => normalizeCoOwnerPersonName(formValues[key]))
    .filter(Boolean);

export const getCoOwnerNameAutocompleteOptions = (
  formValues: Record<string, any>,
  fieldName: string,
  currentValue?: any,
): Array<{ value: string; label: string }> => {
  if (!isCoOwnerCollateralNameField(fieldName)) return [];
  const collateralNum = getCollateralNumberFromCoOwnerField(fieldName);
  const nameOptions = buildCoOwnerNameOptions(formValues);
  const selectedNames = getSelectedCoOwnerNamesForCollateral(
    formValues,
    collateralNum,
    fieldName,
  ).map((name) => name.toLowerCase());
  const current = normalizeCoOwnerPersonName(currentValue).toLowerCase();

  return nameOptions.filter((opt) => {
    const optionValue = String(opt.value || "").trim().toLowerCase();
    return !selectedNames.includes(optionValue) || optionValue === current;
  });
};

export const handleCoOwnerNameSelection = (
  fieldName: string,
  value: any,
  form: any,
  onCount?: (name: string, val: any) => void,
  onDropdownChange?: (name: string, val: any, form: any) => void,
) => {
  const selectedName = normalizeCoOwnerPersonName(value);
  form.setFieldValue(fieldName, value);
  onDropdownChange?.(fieldName, value, form);

  const phoneFieldName = fieldName.replace(/Name$/i, "PhoneNumber");
  const resolvedPhone = resolvePhoneForCoOwnerName(form.values, selectedName);
  if (resolvedPhone) {
    form.setFieldValue(phoneFieldName, resolvedPhone, false);
    onCount?.(phoneFieldName, resolvedPhone);
  }
  onCount?.(fieldName, value);
};

/** Normalize birth-city autocomplete selection to `{ value: code, label: name }`. */
export const normalizeBirthCityOption = (
  value: any,
  cityOptions: Array<{ value?: string | number; label?: string }> = [],
): { value: string; label: string } | "" => {
  if (value === null || value === undefined || value === "") return "";

  const rawValue =
    value && typeof value === "object"
      ? String(value?.value ?? "").trim()
      : String(value ?? "").trim();
  const rawLabel =
    value && typeof value === "object"
      ? String(value?.label ?? value?.value ?? "").trim()
      : String(value ?? "").trim();

  const matched = (cityOptions || []).find((opt) => {
    const optValue = String(opt?.value ?? "").trim().toLowerCase();
    const optLabel = String(opt?.label ?? "").trim().toLowerCase();
    return (
      (rawValue &&
        (optValue === rawValue.toLowerCase() ||
          optLabel === rawValue.toLowerCase())) ||
      (rawLabel &&
        (optValue === rawLabel.toLowerCase() ||
          optLabel === rawLabel.toLowerCase()))
    );
  });

  if (matched) {
    return {
      value: String(matched.value ?? "").trim(),
      label: String(matched.label ?? matched.value ?? "").trim(),
    };
  }

  if (!rawValue && !rawLabel) return "";

  return {
    value: rawValue || rawLabel,
    label: rawLabel || rawValue,
  };
};

/** Resolve birthCityId code from stored field value + city master options. */
export const resolveBirthCityId = (
  raw: any,
  cityOptions: Array<{ value?: string | number; label?: string }> = [],
): string => {
  if (raw === null || raw === undefined || raw === "") return "";

  const rawValue =
    raw && typeof raw === "object" ? String(raw?.value ?? "").trim() : String(raw ?? "").trim();
  const rawLabel =
    raw && typeof raw === "object"
      ? String(raw?.label ?? raw?.value ?? "").trim()
      : String(raw ?? "").trim();

  const matched = (cityOptions || []).find((opt) => {
    const optValue = String(opt?.value ?? "").trim().toLowerCase();
    const optLabel = String(opt?.label ?? "").trim().toLowerCase();
    return (
      (rawValue &&
        (optValue === rawValue.toLowerCase() || optLabel === rawValue.toLowerCase())) ||
      (rawLabel &&
        (optValue === rawLabel.toLowerCase() || optLabel === rawLabel.toLowerCase()))
    );
  });

  // Only a genuine match against the city master list is a verified city
  // code. normalizeBirthCityOption's own no-match fallback echoes the raw
  // stored value back (for display purposes elsewhere) — that raw value can
  // be a label, or even a country name when city master data is missing for
  // that country — so it must never be sent as the birthCityId payload value.
  return matched ? String(matched.value ?? "").trim() : "";
};

export const resolvePhoneForCoOwnerName = (
  rawFormValues: Record<string, any>,
  selectedName: string,
): string => {
  const formValues = withApplicantNameValues(rawFormValues);
  const normalizedSelected = String(selectedName || "").trim();
  if (!normalizedSelected) return "";

  const mainFirst =
    formValues?.firstName || formValues?.studentDetailsFirstName || "";
  const mainLast = formValues?.lastName || formValues?.studentDetailsLastName || "";
  const mainName = [mainFirst, mainLast].filter(Boolean).join(" ");
  if (normalizedSelected === mainName) {
    return String(
      formValues?.phone_number ||
        formValues?.studentDetailsPhone_number ||
        formValues?.mobileNumber ||
        "",
    );
  }

  for (let ci = 1; ci <= 10; ci++) {
    const coFirst = formValues?.[`basicCoApplicant${ci}FirstName`];
    if (!coFirst) continue;
    const coLast = formValues?.[`basicCoApplicant${ci}LastName`] || "";
    const coName = [coFirst, coLast].filter(Boolean).join(" ");
    if (normalizedSelected === coName) {
      return String(formValues?.[`basicCoApplicant${ci}PhoneNumber`] || "");
    }
  }

  return "";
};

/**
 * Identifies whether a co-owner's selected name matches the main applicant or
 * one of the loan's co-applicants, so save-collateral can attach that specific
 * person's own applicantId instead of reusing the main applicant's id for every
 * co-owner row.
 */
export const matchCoOwnerNameToApplicant = (
  rawFormValues: Record<string, any>,
  selectedName: string,
): { type: "main" } | { type: "coApplicant"; coApplicantNumber: number } | null => {
  const formValues = withApplicantNameValues(rawFormValues);
  const normalizedSelected = String(selectedName || "").trim();
  if (!normalizedSelected) return null;

  const mainFirst =
    formValues?.firstName || formValues?.studentDetailsFirstName || "";
  const mainLast = formValues?.lastName || formValues?.studentDetailsLastName || "";
  const mainName = [mainFirst, mainLast].filter(Boolean).join(" ");
  if (mainName && normalizedSelected === mainName) return { type: "main" };

  for (let ci = 1; ci <= 10; ci++) {
    const coFirst = formValues?.[`basicCoApplicant${ci}FirstName`];
    if (!coFirst) continue;
    const coLast = formValues?.[`basicCoApplicant${ci}LastName`] || "";
    const coName = [coFirst, coLast].filter(Boolean).join(" ");
    if (normalizedSelected === coName) {
      return { type: "coApplicant", coApplicantNumber: ci };
    }
  }

  return null;
};

// Co-applicant First Name / Last Name / Mobile are locked once that
// co-applicant is used as a collateral co-owner (name matches and the
// co-owner's phone is the co-applicant's phone), so the link can't break.
export const isCoApplicantFieldLockedByCoOwner = (
  formValues: Record<string, any>,
  fieldName: string,
): boolean => {
  const match = String(fieldName || "").match(
    /^basicCoApplicant(\d+)(FirstName|LastName|PhoneNumber)$/,
  );
  if (!match) return false;
  const coApplicantNumber = Number(match[1]);
  const toValue = (val: any) =>
    val && typeof val === "object" && "value" in val ? val.value : val;
  const lastTenDigits = (val: any) =>
    String(toValue(val) ?? "").replace(/\D/g, "").slice(-10);

  const coApplicantPhone = lastTenDigits(
    formValues?.[`basicCoApplicant${coApplicantNumber}PhoneNumber`],
  );
  if (!coApplicantPhone) return false;

  return Object.keys(formValues || {}).some((key) => {
    if (!isCoOwnerCollateralNameField(key)) return false;
    const coOwnerName = String(toValue(formValues[key]) || "").trim();
    if (!coOwnerName) return false;
    const owner = matchCoOwnerNameToApplicant(formValues, coOwnerName);
    if (owner?.type !== "coApplicant" || owner.coApplicantNumber !== coApplicantNumber) {
      return false;
    }
    const prefix = key.replace(/Name$/i, "");
    return lastTenDigits(formValues?.[`${prefix}PhoneNumber`]) === coApplicantPhone;
  });
};

/**
 * Resolves the real applicantId each co-owner section of a collateral should be
 * saved with: the main applicant's id when the co-owner IS the main applicant,
 * that specific co-applicant's own applicantId (fetched via
 * `fetchCoApplicantApplicantId`) when the co-owner matches a co-applicant, or 0
 * for an unrelated third-party owner. Previously every co-owner row reused the
 * main applicant's id, so collateralOwnershipDetailsDTOList sent the same
 * applicantId for co-owner 1 and co-owner 2.
 */
export const resolveCoOwnerApplicantIdMap = async (
  allFields: any[],
  formValues: Record<string, any>,
  collateralNumber: number,
  mainApplicantId: any,
  fetchCoApplicantApplicantId: (coApplicantType: string) => Promise<any>,
): Promise<Record<string, any>> => {
  const { coOwner } = getCollateralFieldsByGroup(allFields, collateralNumber);
  const sections = splitCoOwnerCollateralSections(coOwner);
  const toValue = (val: any) =>
    val && typeof val === "object" && "value" in val ? val.value : val;

  const result: Record<string, any> = {};
  const fetchCache: Record<number, any> = {};

  for (const sectionFields of sections) {
    const nameField = sectionFields.find((field) =>
      isCoOwnerCollateralNameField(String(field?.name || "")),
    );
    if (!nameField?.name) continue;

    const prefix = String(nameField.name).replace(/Name$/i, "");
    const coOwnerName = String(toValue(formValues?.[nameField.name]) || "").trim();
    if (!coOwnerName) continue;

    const match = matchCoOwnerNameToApplicant(formValues, coOwnerName);
    if (!match) {
      result[prefix] = 0;
      continue;
    }
    if (match.type === "main") {
      result[prefix] = mainApplicantId;
      continue;
    }

    if (fetchCache[match.coApplicantNumber] === undefined) {
      try {
        fetchCache[match.coApplicantNumber] = await fetchCoApplicantApplicantId(
          `Co-Applicant ${match.coApplicantNumber}`,
        );
      } catch {
        fetchCache[match.coApplicantNumber] = 0;
      }
    }
    result[prefix] = fetchCache[match.coApplicantNumber] || 0;
  }

  return result;
};

export const hasDuplicateCoOwnerNamesForCollateral = (
  formValues: Record<string, any>,
  collateralNumber: number,
): boolean => {
  const selectedNames = getSelectedCoOwnerNamesForCollateral(
    formValues,
    collateralNumber,
  ).map((name) => name.toLowerCase());
  return new Set(selectedNames).size !== selectedNames.length;
};

// Co-owner Ownership Percentage as a comparable number (null when blank), so
// "50", "50.0" and { value: "50" } all count as the same value.
export const normalizeOwnershipPercentage = (raw: any): number | null => {
  const value = raw && typeof raw === "object" && "value" in raw ? raw.value : raw;
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

// Single-row ownership edit: a co-owner counts as "edited" only when it has a
// saved percentage AND the live value differs from it. Co-owners with no
// saved percentage yet (being filled in for the first time) never count, so
// filling in a brand-new collateral's co-owners one by one is never blocked.
export const isSavedOwnershipPercentageEdited = (
  currentValue: any,
  savedValue: any,
): boolean => {
  const saved = normalizeOwnershipPercentage(savedValue);
  if (saved === null) return false;
  return normalizeOwnershipPercentage(currentValue) !== saved;
};

export const buildCoOwnerOwnershipDetailsList = (
  allFields: any[],
  formValues: Record<string, any>,
  collateralNumber: number,
  resolvedCollateralId: any,
  applicationId: any,
  applicantIdNumber: any,
  resolvedCollateralOwnerId:any,
  isUpdate: boolean = false,
  ownerAddressId: any = null,
  createdBy: any = null,
  coOwnerApplicantIdByPrefix: Record<string, any> = {},
  fetchedCoOwnerDetails: any[] = [],
) => {
  const { coOwner } = getCollateralFieldsByGroup(allFields, collateralNumber);
  const sections = splitCoOwnerCollateralSections(coOwner);
  const toValue = (val: any) => {
    if (val && typeof val === "object" && "value" in val) return val.value;
    return val;
  };
  // Saved co-owners whose Ownership Percentage was changed in this save.
  const percentageEditedRows: any[] = [];

  const rows = sections
    .map((sectionFields) => {
      const nameField = sectionFields.find((field) =>
        isCoOwnerCollateralNameField(String(field?.name || "")),
      );
      if (!nameField?.name) return null;

      const prefix = String(nameField.name).replace(/Name$/i, "");
      const coOwnerName = String(toValue(formValues?.[nameField.name]) || "");
      const phoneNumber = String(toValue(formValues?.[`${prefix}PhoneNumber`]) || "");
      const ownershipPercentage =
        Number(toValue(formValues?.[`${prefix}OwnershipPercentage`])) || 0;
      // Each co-owner section gets its own applicantId (main applicant, the
      // matched co-applicant, or 0 for an unrelated third party) instead of
      // reusing the main applicant's id for every co-owner row.
      const ownerApplicantId =
        coOwnerApplicantIdByPrefix[prefix] !== undefined
          ? coOwnerApplicantIdByPrefix[prefix]
          : applicantIdNumber;

      if (!coOwnerName && !phoneNumber) return null;

      // Owner ids now come per co-owner in fetch-collateral's
      // collateralOwnerDetails[] — match this section by coOwnerIndex
      // (falling back to the name), else the old top-level ids.
      const ownerIndex = getOwnerIndexFromCoOwnerField(nameField.name);
      const fetchedOwner = Array.isArray(fetchedCoOwnerDetails)
        ? fetchedCoOwnerDetails.find(
            (item: any) => Number(item?.coOwnerIndex) === ownerIndex,
          ) ||
          fetchedCoOwnerDetails.find(
            (item: any) =>
              String(item?.coOwnerName || "").trim().toLowerCase() ===
              coOwnerName.trim().toLowerCase(),
          )
        : undefined;
      const sectionCollateralOwnerId = fetchedOwner
        ? fetchedOwner.collateralOwnerDetailsId ?? null
        : resolvedCollateralOwnerId;
      const sectionOwnerAddressId = fetchedOwner
        ? fetchedOwner.ownerAddressId ?? null
        : ownerAddressId;

      if (!isUpdate) {
        return {
          collateralOwnerDetailsId: null,
          applicationId: Number(applicationId) || applicationId,
          applicantId: ownerApplicantId ? Number(ownerApplicantId): 0,
          ownershipPercentage,
          phoneNumber,
          coOwnerName,
          active: true,
        };
      }

      const row = {
        collateralOwnerDetailsId: sectionCollateralOwnerId?Number(sectionCollateralOwnerId):null,
        collateralId: resolvedCollateralId,
        applicationId: Number(applicationId) || applicationId,
        applicantId:ownerApplicantId? Number(ownerApplicantId) : 0,
        applicationDisplayCode: null,
        bankCustomer: null,
        ownershipPercentage,
        phoneNumber,
        ownerAddressId: Number(sectionOwnerAddressId) || 0,
        ownerAddress: null,
        coOwnerApplicantCIF: null,
        coOwnerName,
        active: true,
        createdBy: createdBy ?? 0,
        createdOn: null,
        modifiedBy: null,
        modifiedOn: null,
      };
      if (
        fetchedOwner &&
        isSavedOwnershipPercentageEdited(ownershipPercentage, fetchedOwner?.ownershipPercentage)
      ) {
        percentageEditedRows.push(row);
      }
      return row;
    })
    .filter((item) => item !== null);

  // Single-row ownership edit: CollateralDetails locks every other co-owner's
  // percentage while one saved co-owner's percentage differs from its saved
  // value, so only that one co-owner is sent. If more than one somehow
  // changed, send the full list rather than silently dropping an edit.
  return percentageEditedRows.length === 1 ? percentageEditedRows : rows;
};

const COLLATERAL_TYPE_ID_FD = 307;
const COLLATERAL_TYPE_ID_PROPERTY = 308;
const COLLATERAL_TYPE_ID_SAVINGS = 309;

const COLLATERAL_TYPE_LABEL_BY_ID: Record<number, string> = {
  [COLLATERAL_TYPE_ID_FD]: "Fixed deposit",
  [COLLATERAL_TYPE_ID_PROPERTY]: "Property",
  [COLLATERAL_TYPE_ID_SAVINGS]: "Savings",
};

/**
 * Builds the `/save-collateral` request body for Property / Fixed Deposit / Savings
 * collateral, matching the exact shape the backend expects for create (collateralId
 * absent) vs update (collateralId present) — the two shapes differ in which keys are
 * present, not just their values (undefined keys are dropped by JSON.stringify).
 */
export const buildSaveCollateralPayload = (params: {
  currentValues: Record<string, any>;
  mergedFields: any[];
  collateralNumber: number;
  applicationId: any;
  applicantId: any;
  resolvedCollateralId: any;
  resolvedCollateralOwnerId: any;
  ownerAddressId?: any;
  createdBy?: any;
  selectedCollateralCodeData?: any;
  resolvedCountryId?: any;
  propertyTypeId?: any;
  propertySubTypeId?: any;
  addressTypeDescription?: any;
  coOwnerApplicantIdByPrefix?: Record<string, any>;
  // Matching record from getCollateralIds — source of the saved sequence values.
  fetchedCollateral?: any;
}): any => {
  const {
    currentValues,
    mergedFields,
    collateralNumber,
    applicationId,
    applicantId,
    resolvedCollateralId,
    resolvedCollateralOwnerId,
    ownerAddressId,
    createdBy,
    selectedCollateralCodeData,
    resolvedCountryId,
    propertyTypeId,
    propertySubTypeId,
    addressTypeDescription: addressTypeDescriptionOverride,
    coOwnerApplicantIdByPrefix,
    fetchedCollateral,
  } = params;

  const toValue = (val: any) =>
    val && typeof val === "object" && "value" in val ? val.value : val;
  const toLabel = (val: any) =>
    val && typeof val === "object" && "label" in val ? val.label : val;
  const toNum = (raw: any): number | null => {
    if (raw === null || raw === undefined || raw === "") return null;
    const candidate =
      typeof raw === "object" && raw !== null && "value" in raw ? raw.value : raw;
    const normalized = String(candidate)
      .replace(/,/g, "")
      .replace(/[^0-9.-]/g, "")
      .trim();
    if (!normalized) return null;
    const parsed = Number(normalized);
    return Number.isNaN(parsed) ? null : parsed;
  };
  const get = (suffix: string) =>
    getCollateralFormValue(currentValues, collateralNumber, suffix);
  // The property type/sub-type dropdown field name varies across form JSON
  // versions (propertyName vs propertyTypeName vs propertyType) — try each.
  const getFirst = (suffixes: string[]) => {
    for (const suffix of suffixes) {
      const value = get(suffix);
      if (value !== undefined && value !== null && String(toValue(value) ?? "") !== "") {
        return value;
      }
    }
    return undefined;
  };
  let applicantIdNumber=applicantId?Number(applicantId):0;
  const collateralTypeRaw = get("Type");
  // The Collateral Type dropdown (SelectOptions) always stores the raw
  // option value/code in Formik, never a { value, label } object — so
  // toLabel() alone silently falls through and returns that code unchanged.
  // Resolve the actual label via mapCollateral() the same way
  // buildCollateralFormDataEntries does for the create-collateral API, so
  // the processio save-collateral API sends the label too instead of the code.
  const collateralType = String(
    mapCollateral().find(
      (opt: any) => String(opt.value) === String(toValue(collateralTypeRaw)),
    )?.label ??
      toLabel(collateralTypeRaw) ??
      "",
  );
  const collateralTypeId =Number(mapCollateral().filter((item:any)=>item.label === collateralType)?.[0]?.value) || 0;

  const isProperty =
    collateralTypeId === COLLATERAL_TYPE_ID_PROPERTY ||
    collateralType.toLowerCase().includes("property");
  const isFd =
    collateralTypeId === COLLATERAL_TYPE_ID_FD ||
    collateralType.toLowerCase().includes("fixed") ||
    collateralType.toLowerCase().includes("fd");
  const isSavings =
    collateralTypeId === COLLATERAL_TYPE_ID_SAVINGS ||
    collateralType.toLowerCase().includes("saving");

  const isUpdate =
    resolvedCollateralId !== null &&
    resolvedCollateralId !== undefined &&
    resolvedCollateralId !== "";

  const collateralAddressId = toNum(get("AddressId"));

  const ownershipDetailsList = buildCoOwnerOwnershipDetailsList(
    mergedFields,
    currentValues,
    collateralNumber,
    resolvedCollateralId,
    applicationId,
    applicantIdNumber,
    resolvedCollateralOwnerId,
    isUpdate,
    ownerAddressId,
    createdBy,
    coOwnerApplicantIdByPrefix || {},
    fetchedCollateral?.collateralOwnerDetails || [],
  );

  let collateralAddress: any;
  let propertyValue: number | null = null;
  let noOfUnits: number | undefined;
  let unitPrice: number | undefined;

  if (isProperty) {
    const cityRaw = get("city");
    const stateRaw = get("state");
    const countryRaw = get("country");
    const pincodeRaw = get("pincode");
    const addressTypeRaw = get("AddressType");
    const countryLabel = String(toLabel(countryRaw) || toValue(countryRaw) || "");

    unitPrice = Number(toValue(get("UnitPrice"))) || 0;
    noOfUnits = Number(toValue(get("NoOfUnits"))) || 0;
    propertyValue = unitPrice * noOfUnits;
    collateralAddress = {
      addressId: collateralAddressId,
      addressLine1: currentValues[`collateral${collateralNumber}addressLine1`] || "",
      addressLine2: currentValues[`collateral${collateralNumber}addressLine2`] || "",
      area: String(toValue(get("Area")) || ""),
      cityId: selectedCollateralCodeData?.city || "",
      cityName: String(toLabel(cityRaw) || toValue(cityRaw) || ""),
      countryId: String(resolvedCountryId || toValue(countryRaw) || ""),
      countryName: countryLabel,
      landmark: String(toValue(get("Landmark")) || ""),
      pincode: String(toValue(pincodeRaw) || ""),
      pincodeId: selectedCollateralCodeData?.pinCodeId
        ? Number(selectedCollateralCodeData.pinCodeId)
        : "",
      stateId: String(selectedCollateralCodeData?.stateCode || ""),
      stateName: String(toLabel(stateRaw) || toValue(stateRaw) || ""),
      addressTypeDescription: String(
        addressTypeDescriptionOverride || toLabel(addressTypeRaw) || "",
      ),
      addressTypeId: String(toValue(addressTypeRaw) || ""),
    };
  } else {
    collateralAddress = {
      addressId: null,
      cityId: "",
      cityName: "",
      countryId: "",
      countryName: "",
      pincode: "",
      pincodeId: "",
      stateId: "",
      stateName: "",
    };
  }

  const payload: any = {
    applicationId: Number(applicationId) || applicationId,
    collateralAddress,
    collateralAddressId: collateralAddress.addressId,
    collateralId: isUpdate ? resolvedCollateralId : null,
    collateralType: COLLATERAL_TYPE_LABEL_BY_ID[collateralTypeId] || collateralType,
    collateralTypeId,
    propertyValue,
    collateralOwnershipDetailsDTOList: ownershipDetailsList,
    // Picked as-is from the same getCollateralIds record collateralId comes
    // from; computed only when that record doesn't exist yet.
    propertySequence: fetchedCollateral
      ? fetchedCollateral.propertySequence ?? null
      : isProperty ? 1 : null,
    fdSequence: fetchedCollateral
      ? fetchedCollateral.fdSequence ?? null
      : isFd ? Number(collateralNumber) || 1 : null,
    savingSequence: fetchedCollateral
      ? fetchedCollateral.savingSequence ?? null
      : isSavings ? Number(collateralNumber) || 1 : null,
  };

  if (isProperty) {
    payload.noOfUnits = noOfUnits;
    payload.unitPrice = unitPrice;
    payload.propertyTypeId = propertyTypeId;
    payload.propertySubTypeId = propertySubTypeId;
  } else {
    payload.collateralValue = Number(toValue(get("Value"))) || 0;
    if (isFd) {
      payload.fdrNumber = Number(toValue(get("FdNumber"))) || 0;
      payload.nameFdHolder = toValue(get("FdHolderName")) || "";
    }
    if (isSavings) {
      payload.accountNumber = Number(toValue(get("AccountNumber"))) || 0;
      payload.holderName = toValue(get("holderName")) || "";
    }
  }

  return payload;
};

const normalizeStepLabel = (label: string): string =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, " ");

/**
 * Maps a vertical step display name to the Redux/form JSON vertical index.
 * Mirrors gotoDynamicForm in ApplicationDetails; use when UI cards skip steps
 * (e.g. Co-Applicant filtered from Additional Details).
 */
export const resolveReduxVerticalIndex = (
  verticalStepName: string,
  horizontalLabel?: string,
  reduxHorizontalSteps?: any[],
): number => {
  const n = normalizeStepLabel(verticalStepName);

  if (
    n === "applicant additional details" ||
    n === "additional applicant details"
  ) {
    return 0;
  }
  if (
    n === "co-applicant additional details" ||
    n === "co-applicant aditional details"
  ) {
    return 1;
  }
  if (n === "funds and expenses") {
    return 2;
  }
  if (
    n === "reference and collateral details" ||
    n === "reference details" ||
    n === "collateral details"
  ) {
    return 3;
  }

  if (horizontalLabel && Array.isArray(reduxHorizontalSteps)) {
    const horizontalStep = reduxHorizontalSteps.find(
      (step: any) => step?.stepLabel === horizontalLabel,
    );
    const verticalSteps = horizontalStep?.verticalSteps ?? [];
    const exactIdx = verticalSteps.findIndex(
      (step: any) => step?.stepLabel === verticalStepName,
    );
    if (exactIdx !== -1) return exactIdx;

    const fuzzyIdx = verticalSteps.findIndex(
      (step: any) => normalizeStepLabel(step?.stepLabel) === n,
    );
    if (fuzzyIdx !== -1) return fuzzyIdx;
  }

  return 0;
};

export const getVerticalStepLabel = (hStepKey: string, vIdx: number,reduxHorizontalSteps:any): string => {
  // 1. Find the parent horizontal step (e.g., 'additional_details_and_documents')
  const horizontalStep = reduxHorizontalSteps?.find(
    (step:any) => step.stepLabel === hStepKey
  );
  // 2. Grab its verticalSteps array (fallback to empty array if missing)
  const originalVerticalSteps = horizontalStep?.verticalSteps ?? [];

  // 3. Filter out the Co-Applicant step dynamically
  const filteredVerticalSteps = originalVerticalSteps.filter(
    (step:any) => !step.stepLabel.includes('Co-Applicant Aditional Details')
  );

 // 4. Return the stepLabel based on your current vertical index
  return filteredVerticalSteps[vIdx]?.stepLabel ?? "";
};

export interface Response1Field {
  label: string;
  name: string;
  key: string;
  value: string | number | boolean;
}

export interface CoApplicantGroup {
  [coApplicantKey: string]: Response1Field[];
}

export interface Response2Field {
  id: number;
  label: string;
  name: string;
  type: string;
  required: boolean;
  options: any;
  fieldOrder: number;
  isRemoved: boolean;
}

export interface Response2Step {
  id: number;
  stepLabel: string;
  stepOrder: number;
  fields: Response2Field[];
}

export function mergeMissingCoApplicants(
  response1: CoApplicantGroup[] | null | undefined,
  response2: Response2Step[]
): CoApplicantGroup[] {
  if (response1 == null) {
    return [];
  }

  const safeResponse1 = Array.isArray(response1) ? response1 : [];
  const updatedResponse1: CoApplicantGroup[] = JSON.parse(
    JSON.stringify(safeResponse1),
  );
  function deriveResponse1Name(key: string, coAppNum: string): string {
      if (key.includes("RelationWithStudent")) {
          return `coApplicant${coAppNum}RelationWithStudent`;
      } else if (key.endsWith("FirstName") || key.endsWith("LastName")) {
          return `coApplicant${coAppNum}Name`;
      } else if (key.endsWith("Email")) {
          return `coApplicant${coAppNum}Email`;
      } else if (key.endsWith("PanNumber")) {
          return `coApplicant${coAppNum}PanNumber`;
      } else if (key.endsWith("IsPanVerified")) {
          return `coApplicant${coAppNum}IsPanVerified`;
      } else if (key.endsWith("IsMobileVerified")) {
          return `coApplicant${coAppNum}IsMobileVerified`;
      } else if (key.endsWith("IsEmailVerified")) {
          return `coApplicant${coAppNum}IsEmailVerified`;
      } else {
          return key; 
      }
  }

  response2.forEach((step) => {
      if (!step.fields || !Array.isArray(step.fields)) return;

      step.fields.forEach((field) => {
          const fieldName = field.name || "";
          const coAppMatch = fieldName.match(/coApplicant(\d+)/i);
          if (!coAppMatch) return; 

          const coAppNum = coAppMatch[1]; 
          const coAppGroupKey = `coapplicant${coAppNum}`; 

          let coAppGroupObj = updatedResponse1.length!=undefined && updatedResponse1?.find((item) =>
              Object.prototype.hasOwnProperty.call(item, coAppGroupKey)
          );
          
          if (!coAppGroupObj && updatedResponse1.length!=undefined) {
              coAppGroupObj = { [coAppGroupKey]: [] };
              updatedResponse1.push(coAppGroupObj);
          }

          let coAppArray =coAppGroupObj &&  coAppGroupObj[coAppGroupKey];

          const derivedName = deriveResponse1Name(fieldName, coAppNum);
          const normalizedIncomingLabel = String(field.label || "").trim().toLowerCase();
          const isFieldAlreadyExists = coAppArray && coAppArray.some((item:any) => {
              if (item.key === fieldName || item.name === derivedName) return true;
              const existingLabel = String(item.label || "").trim().toLowerCase();
              return normalizedIncomingLabel !== "" && existingLabel === normalizedIncomingLabel;
          });

          if (!isFieldAlreadyExists && Array.isArray(coAppArray)) {
              coAppArray.push({
                  label: field.label || "",
                  name: derivedName,
                  key: fieldName,
                  value: ""
              });
          }
      });
  });

  return updatedResponse1;
}

// syncResponseUtils.ts

export interface Response1Field {
  label: string;
  name: string;
  key: string;
  value: string | number | boolean;
}

export interface Response1CoApplicantElement {
  [coApplicantKey: string]: Response1Field[];
}

export interface Response2CoApplicantFields {
  [fieldKey: string]: string | number | boolean;
}

export interface Response2DataStructure {
  [coApplicantKey: string]: Response2CoApplicantFields;
}

export function syncResponse1ToResponse2(
  response1: Response1CoApplicantElement[],
  response2: Response2DataStructure
): Response2DataStructure {
  const updatedResponse2: Response2DataStructure = response2?JSON.parse(JSON.stringify(response2)):{};
  function extractShortKeyForResponse2(r1Key: string, coAppNum: string): string {
      const prefixes = ["basic", "address", "employment"];
      let cleanedKey = r1Key;

      for (const prefix of prefixes) {
          if (cleanedKey && cleanedKey?.startsWith(prefix)) {
              cleanedKey = cleanedKey.slice(prefix.length);
              break;
          }
      }

      const coAppTarget = `CoApplicant${coAppNum}`;
      if (cleanedKey && cleanedKey?.startsWith(coAppTarget)) {
          cleanedKey = cleanedKey.slice(coAppTarget.length);
      }

      if (cleanedKey?.toLowerCase() === "dob") return "dob";
      if (cleanedKey?.toLowerCase() === "salutation") return "salutation";

      return cleanedKey;
  }
  if (response1 !== undefined && response1 !== null&& response1.length!=undefined) {
    response1?.forEach((coAppObj, index) => {
        const coAppGroupKey = Object.keys(coAppObj)[0]; 
        if (!coAppGroupKey) return;
        const match = coAppGroupKey.match(/\d+/);
        const coAppNum = match ? match[0] : "1";
        const r1FieldsArray = coAppObj[coAppGroupKey];
        if (typeof updatedResponse2 === "object" && !updatedResponse2[coAppGroupKey] && coAppGroupKey) {
            updatedResponse2[coAppGroupKey] = {};
        }
        r1FieldsArray.forEach((field) => {
            const shortFieldKey = extractShortKeyForResponse2(field.key, coAppNum);
            if (typeof updatedResponse2 === "object" && !(shortFieldKey in updatedResponse2[coAppGroupKey])) {
                updatedResponse2[coAppGroupKey][shortFieldKey] = "";
            }
        });
    });
  }
  return updatedResponse2;
}

export function getCoApplicantFieldIds(jsonData: any, coapplicantNumber: number): number[] {
  const fieldIds: number[] = [];
  const steps = jsonData;
  if (!steps || !Array.isArray(steps)) return [];

  // Define targets based on user prompt (using 0-based indexes for array lookups)
  // Target 1: Horizontal Index 1 -> Vertical Index 5
  // Target 2: Horizontal Index 3 -> Vertical Index 1
  const targets = [
    { hIdx: 1, vIdx: 5 },
    { hIdx: 3, vIdx: 1 }
  ];

  // Helper string to identify fields matching our specific coapplicant (e.g., "coapplicant1")
  const matchKey = `coapplicant${coapplicantNumber}`.toLowerCase();
  targets.forEach(({ hIdx, vIdx }) => {
    const horizontalStep = steps[hIdx];
    const verticalStep = horizontalStep?.verticalSteps?.[vIdx];
    const fields = verticalStep?.fields;
    if (fields && Array.isArray(fields)) {
      fields.forEach((field: any) => {

        // Match if the field name contains our target coapplicant identifier
        if (field?.name && field.name.toLowerCase().includes(matchKey)) {
          fieldIds.push(field.id);
        }
      });
    }
  });

  return fieldIds;
}
export function getCoAppPercentageByIndices(stepsArray:any,formikData:any) {
  // --- PART 1: Horizontal Index 1, Vertical Index 5 ---
  let size=Object.entries(formikData || {}).length < 2 ?2:Object.entries(formikData || {}).length;
  const hStep1 = stepsArray[1]; 
  const vStep1 = hStep1?.verticalSteps?.[5];
  const sections = vStep1?.sections || [];
  // 1. Automatically find all unique Co-Applicant numbers present in the section names
  const coAppNumbers = new Set();
  const coAppNumbers2 = new Set();
  const coAppRegex = /Co Applicant (\d+)/;

  sections.forEach((s:any) => {
    const match = s.sectionName.match(coAppRegex);
    if (match) {
      coAppNumbers.add(parseInt(match[1], 10)); // e.g., extracts 1 or 2
    }
  });

  // If no co-applicants are found in the data, return 0%
  if (coAppNumbers.size === 0) {
   return 0;
  }

  // --- PART 2: Horizontal Index 3, Vertical Index 1 ---
  const hStep2 = stepsArray[3];
  const vStep2 = hStep2?.verticalSteps?.[1];
  const sections2 = vStep2?.sections || [];
  sections2.forEach((s:any) => {
    const matcht = s.sectionName.match(coAppRegex);
    if (matcht) {
      coAppNumbers2.add(parseInt(matcht[1], 10)); // e.g., extracts 1 or 2
    }
  });

  // --- 3. CALCULATE PERCENATGES FOR EACH FOUND CO-APPLICANT ---
  let totalCoAppsSum = 0;
  const breakdown = [];
  const mergedSet = new Set(coAppNumbers || []);

  if (coAppNumbers2) {
    coAppNumbers2.forEach((num) => mergedSet.add(num));
  }
  mergedSet.forEach(coAppNum => {
    // Dynamically build target sections for the detected co-applicant number
    const targetSections = [
      `Co Applicant ${coAppNum} Basic Details`,
      `Co Applicant ${coAppNum} Address Details`,
      `Co Applicant ${coAppNum} Employment Details`
    ];

    let sumPart1 = 0;
    let sumPart2 = 0;
    targetSections.forEach(name => {
      const match = sections.find((s:any) => s.sectionName === name);
      if (match) {
        sumPart1 += parseFloat(match.completionPercentage || 0);
      }
    });
    targetSections.forEach(name => {
      const match2 = sections2.find((s:any) => s.sectionName === name);
      
      if (match2) {
        sumPart2 += parseFloat(match2?.completionPercentage || 0);
      }
    });

    const part1Average = sumPart1 / 3;
    const part2Average = sumPart2 / 3;
    let coappsize=mergedSet.size
    const overallCoAppPercentage = (part1Average + part2Average) / size;
    totalCoAppsSum += overallCoAppPercentage;
    
  });

  // --- 4. FINAL AVERAGING BY NUMBER OF CO-APPLICANTS ---
  const grandAverage = totalCoAppsSum;

  return  Number(grandAverage.toFixed(2));
}
export const checkAllMandatoryDocumentsUploaded = (allDocsData: any[],formUserData:any) => {
  const missingDocuments: any[] = [];
  allDocsData.forEach((applicantData: any) => {
    applicantData.documents.forEach((category: any) => {
      const mandatoryDocs = category?.documents?.filter(
        (doc: any) => (doc?.docNameDms !== "offer_letter" && doc?.isMandatory === true) || (doc?.isMandatory === true  && (formUserData?.admissionStatus?.toLowerCase() === "confirmed"))
      );
      mandatoryDocs?.forEach((doc: any) => {
        if (!doc?.userDocs || doc?.userDocs?.length === 0) {
          missingDocuments.push({
            applicantType: applicantData.applicantType,
            categoryName: category.name,
            docName: doc.docName,
          });
        }
      });  
    });
  });

  return {
    allUploaded: missingDocuments.length === 0,
    missingDocuments,
  };
};

export function splitCoOwnersIntoSections(apiResponseArray: any[]) {
  const result: any[] = []; 

  if (!Array.isArray(apiResponseArray) || apiResponseArray.length === 0) {
    return result;
  }

  // Temporary object to group fields by their person key (e.g., "1_1", "1_2")
  const groupings: Record<string, any[]> = {};

  // 1-2. Ownership can arrive as one object holding every owner
  // ([{ owner1: [...], owner2: [...] }]) or as one object per owner
  // ([{ owner1: [...] }, { owner2: [...] }] — partner journey API). Walk every
  // entry so the 2nd+ co-owners aren't dropped.
  apiResponseArray.forEach((dataObject: any) => {
    Object.keys(dataObject || {}).forEach((mainKey) => {
      const fields = Array.isArray(dataObject[mainKey]) ? dataObject[mainKey] : [];
      fields.forEach((field: any) => {
        if (!field?.name) return;
        const match = field.name.match(/coOwnerCollateral(\d+)(?:_(\d+))?/) ||field.name.match(/owner(\d+)(?:_(\d+))?/) ;

        if (match) {
          const primaryIdx = match[1];
          const subIdx = match[2] || "1";
          const groupKey = `${primaryIdx}_${subIdx}`; // e.g., "1_1" or "1_2"

          if (!groupings[groupKey]) {
            groupings[groupKey] = [];
          }
          groupings[groupKey].push(field);
        }
      });
    });
  });

  // 3. Convert grouped fields into separate structured objects inside a single array
  Object.keys(groupings)
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .forEach((groupKey) => {
      const fields = groupings[groupKey];
      
      // Extract indices for contextual tracking properties if you need them
      const [collateralId, personId] = groupKey.split('_');

      // Build a clean, key-agnostic data representation for this person
      const CO_OWNER_FIELD_ORDER = ["name", "ownershippercentage", "phonenumber"];
      const getCoOwnerFieldRank = (label: string) => {
        const normalized = label.toLowerCase().replace(/[^a-z]/g, "");
        const idx = CO_OWNER_FIELD_ORDER.findIndex((token) =>
          normalized.includes(token),
        );
        return idx === -1 ? CO_OWNER_FIELD_ORDER.length : idx;
      };
      const coOwnerObject = {
        id: groupKey, // unique reference "1_1", "1_2"
        collateralIndex: parseInt(collateralId, 10),
        personIndex: parseInt(personId, 10),
        // Clean up the fields array for this specific person, in Name ->
        // Ownership Percentage -> Phone Number order regardless of the
        // order the API returned them in.
        fields: fields
          .map((field: any) => ({
            name: field.name,
            label: field.label.replace(/^_\d+\s+/, ""), // Clean up "_2 " label formatting
            value: field.value
          }))
          .sort(
            (a: any, b: any) =>
              getCoOwnerFieldRank(a.label) - getCoOwnerFieldRank(b.label),
          )
      };

      result.push(coOwnerObject);
    });

  return result;
}
export const isUploadOptionShow = (docSecName: string, status: string): boolean => {
  if ((docSecName === "Academic Documents" || docSecName === "Income Document") && 
  (status === "Sanctioned" || status === "Application Rejected" || status === "Application Closed" || status === "Declined by Credit" || status === "Disbursed")) {
    return false;
  } 
  return true; 
}
/**
 * Checks if all email and mobile verifications are complete.
 * 
 * @param {Object} data - The input data payload.
 * @returns {boolean} - Returns false if ANY email or mobile is unverified (false), otherwise true.
 */
export const  areAllVerificationsComplete=(data:any) =>{
  // Regex to match any email or mobile verification key
  const verificationRegex = /(IsEmailVerified|IsMobileVerified|isEmailVerified|isMobileVerified)$/i;

  for (const key of Object.keys(data)) {
    if (verificationRegex.test(key)) {
      const value = data[key];
      // Convert value to boolean check (handles boolean true/false or string "true"/"false")
      const isVerified = String(value).toLowerCase() === "true";

      // If any verification key is false, immediately return false
      if (!isVerified) {
        return false;
      }
    }
  }

  // Returns true only if all checked fields were true
  return true;
}

// ─── Fund & Expense section (Course Duration Funds) ──────────────────────────
// Shared between DynamicForm.tsx and FormEdit.tsx so both stay in sync.
export const FUND_EXPENSE_LOAN_AMOUNT_FIELD = "fundRequestedLoanAmount";
export const FUND_EXPENSE_VAS_FIELD = "expenseVasExpense";
// All Fund/Expense fields whose requiredness depends on admissionStatus,
// other than the loan amount itself (which has its own always-required-when-
// filled-alone carve-out — see getFundExpenseValidationState) and VAS Expense
// (disabled/read-only; its requiredness is driven by its own schema flag).
export const FUND_EXPENSE_CONDITIONAL_FIELDS = [
  "expenseTuitionFees",
  "expenseLivingExpenses",
  "expenseTravelExpenses",
  "expenseOtherExpenses",
  "fundOwnSources",
  "fundScholarshipAmount",
  "fundOtherIncome",
];
// All Fund/Expense currency fields that get Indian-comma formatting — used to
// widen the generic currency-field detection in DynamicForm/FormEdit's
// renderField, since a couple of these names (expenseVasExpense,
// fundOwnSources) don't contain any of that detector's generic keywords.
export const FUND_EXPENSE_CURRENCY_FIELDS = [
  ...FUND_EXPENSE_CONDITIONAL_FIELDS,
  FUND_EXPENSE_LOAN_AMOUNT_FIELD,
  FUND_EXPENSE_VAS_FIELD,
];

const extractScalarValue = (raw: any) => {
  if (raw && typeof raw === "object") {
    return "value" in raw ? raw.value : "label" in raw ? raw.label : raw;
  }
  return raw;
};

export const isFundExpenseValueFilled = (raw: any): boolean => {
  const value = extractScalarValue(raw);
  if (value === null || value === undefined) return false;
  return String(value).replace(/,/g, "").trim() !== "";
};

export const isAdmissionStatusConfirmed = (values: any): boolean => {
  const value = extractScalarValue(values?.admissionStatus);
  return String(value ?? "").trim().toLowerCase() === "confirmed";
};

export interface FundExpenseValidationState {
  isConfirmed: boolean;
  isLoanAmountFilled: boolean;
  /** Only the loan amount is filled, every other fund/expense field is empty — allowed shortcut. */
  isOnlyLoanAmountProvided: boolean;
  /** Loan amount plus every other conditional field is filled. */
  areAllFieldsFilled: boolean;
  /** False only when admissionStatus is CONFIRMED and the fields are in neither valid state above. */
  isValid: boolean;
  /** Field names still missing when isValid is false — for surfacing inline errors. */
  missingFieldNames: string[];
}

/**
 * Fund & Expense fields are required when admissionStatus is CONFIRMED — except
 * the user may provide ONLY the Requested Loan Amount and continue without the
 * rest. Filling in anything else means every conditional field must be filled.
 */
export const getFundExpenseValidationState = (values: any): FundExpenseValidationState => {
  const isConfirmed = isAdmissionStatusConfirmed(values);
  const isLoanAmountFilled = isFundExpenseValueFilled(values?.[FUND_EXPENSE_LOAN_AMOUNT_FIELD]);
  const filledOtherFields = FUND_EXPENSE_CONDITIONAL_FIELDS.filter((name) =>
    isFundExpenseValueFilled(values?.[name]),
  );
  const isOnlyLoanAmountProvided = isLoanAmountFilled && filledOtherFields.length === 0;
  const areAllFieldsFilled =
    isLoanAmountFilled && filledOtherFields.length === FUND_EXPENSE_CONDITIONAL_FIELDS.length;
  
    const isValid =isOnlyLoanAmountProvided || isLoanAmountFilled || values?.admissionStatus?.toLowerCase() === "undecided";

  const missingFieldNames = isValid
    ? []
    : [
        ...(isLoanAmountFilled ? [] : [FUND_EXPENSE_LOAN_AMOUNT_FIELD]),
        ...FUND_EXPENSE_CONDITIONAL_FIELDS.filter((name) => !filledOtherFields.includes(name)),
      ];

  return {
    isConfirmed,
    isLoanAmountFilled,
    isOnlyLoanAmountProvided,
    areAllFieldsFilled,
    isValid,
    missingFieldNames,
  };
};

type ReferenceData = Record<string, unknown>;

/**
 * Checks whether all specified key prefixes exist in the dataset 
 * and contain non-empty data.
 * 
 * @param data - The dataset object to check.
 * @param prefixes - Array of key prefixes to check (e.g., ['basicReference1', 'basicReference2', 'collateral1']).
 * @returns `true` if every prefix has at least one valid non-empty field, otherwise `false`.
 */
export function hasDataForPrefixes(
  data: ReferenceData | null | undefined,
  prefixesu:any
): boolean {
  const prefixes = ["basicReference1", "basicReference2", "collateral1"];
  const prefixeso= ["basicReference1", "basicReference2"];
  if (!data || typeof data !== "object") {
    return false;
  }
  if(prefixesu==="No"){
    return prefixeso.every((prefix:any) => {
      // Find all keys starting with the current prefix
      const matchingKeys = Object.keys(data).filter((key) => key.startsWith(prefix));

      // Ensure at least one matching key exists and has a non-empty value
      return (
        matchingKeys.length > 0 &&
        matchingKeys.some((key) => {
          const val = data[key];
          if (val === null || val === undefined) return false;
          return String(val).trim() !== "";
        })
      );
    });
  }else{
    return prefixes.every((prefix:any) => {
      // Find all keys starting with the current prefix
      const matchingKeys = Object.keys(data).filter((key) => key.startsWith(prefix));

      // Ensure at least one matching key exists and has a non-empty value
      return (
        matchingKeys.length > 0 &&
        matchingKeys.some((key) => {
          const val = data[key];
          if (val === null || val === undefined) return false;
          return String(val).trim() !== "";
        })
      );
    });
  }
}

export const gotoPageStepOrLoanOverviewPage = async (applicationNumber: string) => {
    let isLoanOverview = false;
    try {
      const response = await applicationDetailsServices.documentCompletion(applicationNumber);
     
      if(response && response?.status === 200) {
        if(response?.data?.data?.allMandatoryDocumentsUploaded) {
          isLoanOverview = true;
        }
      }
      return isLoanOverview;
    } catch(err) {
      console.log("Error while getting doument details");
      return isLoanOverview;
    }
}



export function isDeviceTypeMobile(isXsOrSm: boolean): Boolean {
  const deviceType = sessionStorage.getItem("deviceType");
  return isXsOrSm && (deviceType != null &&
         deviceType != undefined &&
         deviceType != "" &&
         deviceType === "mobile");
}

export function findApplicantStep(data:any) {
    let targetName = "Applicant Additional Details"
    if (!data || !Array.isArray(data.verticalSteps)) {
      return false;
    }
    let stepData=data?.verticalSteps?.find((step:any) => 
      step.verticalStepName === targetName || 
      step.stepLabel === targetName ||
      step.name === targetName
    ) || null;
    if (!stepData || !Array.isArray(stepData.fields) || stepData.fields.length === 0) {
      return false;
    }
    const REQUIRED_APPLICANT_FIELDS = [
      'applicantDependents',
      'applicantNationality',
      'applicantMaritalStatus',
      'applicantBirthCountry',
      'applicantCityCountry',
      'loanLoanAmount',
      'loanLoanTenure',
      'loanRequestedRoi',
      'loanDateOfDisbursement'
    ];
    const fieldsMapOne = stepData?.fields;
    const fieldsMap = Object.assign({}, ...fieldsMapOne);
        
    return REQUIRED_APPLICANT_FIELDS.every((requiredKey) => {
      const value = fieldsMap[requiredKey];
     
      // Checks for presence, null, undefined, and non-empty string after trimming
      return (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== ''
      );
    });
  };

  export function checkVerificationStatus(applications:any, checkIdentity: boolean = false) {
  // Config: Isme aap dynamic regex (pattern) ya key names pass kar sakte hain
  // Match karega koi bhi CoApplicant mobile/email (ya pan/aadhaar) verification
  // key, jaise basicCoApplicant1IsMobileVerified, basicCoApplicant2IsPanVerified.
  const coApplicantKeyPatterns = checkIdentity
    ? [/.*basicCoApplicant.*IsPanVerified/i, /.*basicCoApplicant.*AadhaarVerified/i]
    : [/.*basicCoApplicant.*IsMobileVerified/i, /.*basicCoApplicant.*IsEmailVerified/i];

  const targetConfig = [
    checkIdentity
      // Unlike email/mobile (under "Eligibility Check" > "Verify Yourself and
      // Provide Consent"), the applicant's isPanVerified/isAadhaarVerified
      // fields live under "Applicant & Loan Details" > "Student Details".
      ? {
          horizontalStepName: "Applicant & Loan Details",
          verticalStepName: "Student Details",
          keyPatterns: [/^isPanVerified$/i, /^isAadhaarVerified$/i]
        }
      : {
          horizontalStepName: "Eligibility Check",
          verticalStepName: "Verify Yourself and Provide Consent",
          keyPatterns: [/isMobileVerified/i, /isEmailVerified/i]
        },
    {
      horizontalStepName: "Applicant & Loan Details",
      verticalStepName: "Co-Applicant Details",
      keyPatterns: coApplicantKeyPatterns
    },
    {
      horizontalStepName: "Additional Details & Documents",
      verticalStepName: "Co-Applicant Aditional Details",
      keyPatterns: coApplicantKeyPatterns
    }
  ];
  const horizontalSteps = applications?.horizontalSteps || [];

  for (const config of targetConfig) {
    const hStep = horizontalSteps.find(
      (h:any) => h.horizontalStepName === config.horizontalStepName
    );
    if (!hStep) continue;

    const vStep = hStep.verticalSteps?.find(
      (v:any) => v.verticalStepName === config.verticalStepName
    );
    if (!vStep) continue;

    const fields = vStep.fields || [];

    // Fields array ke sabhi objects ko check karein
    for (const fieldObj of fields) {
      for (const [key, value] of Object.entries(fieldObj)) {
        
        // Check karein ki kya yeh key hamare dynamic pattern se match karti hai
        const isMatchingKey = config.keyPatterns.some((pattern) => pattern.test(key));

        if (isMatchingKey) {
          // Check Boolean `false`, String `"false"`, `null`, ya `undefined`
          if (value === false || value === "false" || value === null || value === undefined) {
           
            return false; // Koyi bhi ek unverified/false mile toh direct false return karo
          }
        }
      }
    }
  }

  return true; // Sabhi dynamic verified keys valid/true mili
}